{
    "Constellations": [
        {
            "Name": "Andromeda",
            "RAh": 0.139805556,
            "DEd": 29.09055556,
            "stars": [
                {
                    "id": 0,
                    "bfID": "21Alp And",
                    "RAh": 0.139805556,
                    "DEd": 29.09055556
                },
                {
                    "id": 1,
                    "bfID": "31Del And",
                    "RAh": 0.655472222,
                    "DEd": 30.86083333
                },
                {
                    "id": 2,
                    "bfID": "43Bet And",
                    "RAh": 1.162194444,
                    "DEd": 35.62055556
                },
                {
                    "id": 3,
                    "bfID": "57Gam1And",
                    "RAh": 2.065,
                    "DEd": 42.32972222
                },
                {
                    "id": 4,
                    "bfID": "29Pi And",
                    "RAh": 0.614694444,
                    "DEd": 33.71944444
                },
                {
                    "id": 5,
                    "bfID": "37Mu And",
                    "RAh": 0.945888889,
                    "DEd": 38.49944444
                },
                {
                    "id": 6,
                    "bfID": "46Xi And",
                    "RAh": 1.372333333,
                    "DEd": 45.52888889
                },
                {
                    "id": 7,
                    "bfID": "51 And",
                    "RAh": 1.633222222,
                    "DEd": 48.62833333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    0,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Cygnus",
            "RAh": 20.62,
            "DEd": 42.03,
            "stars": [
                {
                    "id": "0",
                    "bfID": "50Alp Cyg",
                    "RAh": 20.69052778,
                    "DEd": 45.28027778
                },
                {
                    "id": "1",
                    "bfID": "37Gam Cyg",
                    "RAh": 20.37047222,
                    "DEd": 40.25666667
                },
                {
                    "id": "2",
                    "bfID": "18Del Cyg",
                    "RAh": 19.74958333,
                    "DEd": 45.13083333
                },
                {
                    "id": "3",
                    "bfID": "13The Cyg",
                    "RAh": 19.60736111,
                    "DEd": 50.22111111
                },
                {
                    "id": "4",
                    "bfID": "53Eps Cyg",
                    "RAh": 20.77019444,
                    "DEd": 33.97027778
                },
                {
                    "id": "5",
                    "bfID": "64Zet Cyg",
                    "RAh": 21.21561111,
                    "DEd": 30.22694444
                },
                {
                    "id": "6",
                    "bfID": "21Eta Cyg",
                    "RAh": 19.93844444,
                    "DEd": 35.08333333
                },
                {
                    "id": "7",
                    "bfID": "6Bet1Cyg",
                    "RAh": 19.51202778,
                    "DEd": 27.95972222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    1,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    1,
                    6
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Ursa Major",
            "RAh": 11,
            "DEd": 56,
            "stars": [
                {
                    "id": "0",
                    "bfID": "50Alp UMa",
                    "RAh": 11.06213889,
                    "DEd": 61.75083333
                },
                {
                    "id": "1",
                    "bfID": "48Bet UMa",
                    "RAh": 11.03069444,
                    "DEd": 56.3825
                },
                {
                    "id": "2",
                    "bfID": "64Gam UMa",
                    "RAh": 11.89716667,
                    "DEd": 53.69472222
                },
                {
                    "id": "3",
                    "bfID": "69Del UMa",
                    "RAh": 12.25711111,
                    "DEd": 57.0325
                },
                {
                    "id": "4",
                    "bfID": "77Eps UMa",
                    "RAh": 12.90047222,
                    "DEd": 55.95972222
                },
                {
                    "id": "5",
                    "bfID": "79Zet UMa",
                    "RAh": 13.39875,
                    "DEd": 54.92527778
                },
                {
                    "id": "6",
                    "bfID": "85Eta UMa",
                    "RAh": 13.79233333,
                    "DEd": 49.31333333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    0,
                    3
                ]
            ]
        },
        {
            "Name": "Orion",
            "RAh": 5,
            "DEd": 5,
            "stars": [
                {
                    "id": "0",
                    "bfID": "58Alp Ori",
                    "RAh": 5.919527778,
                    "DEd": 7.406944444
                },
                {
                    "id": "1",
                    "bfID": "39Lam Ori",
                    "RAh": 5.585638889,
                    "DEd": 9.934166667
                },
                {
                    "id": "2",
                    "bfID": "24Gam Ori",
                    "RAh": 5.418861111,
                    "DEd": 6.349722222
                },
                {
                    "id": "3",
                    "bfID": "34Del Ori",
                    "RAh": 5.533444444,
                    "DEd": -0.299166667
                },
                {
                    "id": "4",
                    "bfID": "46Eps Ori",
                    "RAh": 5.603555556,
                    "DEd": -1.201944444
                },
                {
                    "id": "5",
                    "bfID": "50Zet Ori",
                    "RAh": 5.679305556,
                    "DEd": -1.942777778
                },
                {
                    "id": "6",
                    "bfID": "53Kap Ori",
                    "RAh": 5.795944444,
                    "DEd": -9.669722222
                },
                {
                    "id": "7",
                    "bfID": "19Bet Ori",
                    "RAh": 5.242305556,
                    "DEd": -8.201666667
                },
                {
                    "id": "8",
                    "bfID": "61Mu Ori",
                    "RAh": 6.039722222,
                    "DEd": 9.6475
                },
                {
                    "id": "9",
                    "bfID": "70Xi Ori",
                    "RAh": 6.199,
                    "DEd": 14.20888889
                },
                {
                    "id": "10",
                    "bfID": "67Nu Ori",
                    "RAh": 6.126194444,
                    "DEd": 14.76833333
                },
                {
                    "id": "11",
                    "bfID": "54Chi1Ori",
                    "RAh": 5.906361111,
                    "DEd": 20.27611111
                },
                {
                    "id": "12",
                    "bfID": "62Chi2Ori",
                    "RAh": 6.065333333,
                    "DEd": 20.13833333
                },
                {
                    "id": "13",
                    "bfID": "1Pi 3Ori",
                    "RAh": 4.830666667,
                    "DEd": 6.961388889
                },
                {
                    "id": "14",
                    "bfID": "2Pi 2Ori",
                    "RAh": 4.843527778,
                    "DEd": 8.900277778
                },
                {
                    "id": "15",
                    "bfID": "9Omi2Ori",
                    "RAh": 4.939527778,
                    "DEd": 13.51444444
                },
                {
                    "id": "16",
                    "bfID": "3Pi 4Ori",
                    "RAh": 4.853444444,
                    "DEd": 5.605
                },
                {
                    "id": "17",
                    "bfID": "8Pi 5Ori",
                    "RAh": 4.904194444,
                    "DEd": 2.440555556
                },
                {
                    "id": "18",
                    "bfID": "10Pi 6Ori",
                    "RAh": 4.975805556,
                    "DEd": 1.714166667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    0
                ],
                [
                    5,
                    6
                ],
                [
                    3,
                    7
                ],
                [
                    7,
                    6
                ],
                [
                    0,
                    8
                ],
                [
                    8,
                    9
                ],
                [
                    9,
                    10
                ],
                [
                    10,
                    11
                ],
                [
                    9,
                    12
                ],
                [
                    11,
                    12
                ],
                [
                    2,
                    15
                ],
                [
                    13,
                    14
                ],
                [
                    14,
                    15
                ],
                [
                    13,
                    16
                ],
                [
                    16,
                    17
                ],
                [
                    17,
                    18
                ]
            ]
        },
        {
            "Name": "Lyra",
            "RAh": 18.75,
            "DEd": 36,
            "stars": [
                {
                    "id": "0",
                    "bfID": "3Alp Lyr",
                    "RAh": 18.61563889,
                    "DEd": 38.78361111
                },
                {
                    "id": "1",
                    "bfID": "6Zet1Lyr",
                    "RAh": 18.74622222,
                    "DEd": 37.605
                },
                {
                    "id": "2",
                    "bfID": "12Del2Lyr",
                    "RAh": 18.90838889,
                    "DEd": 36.89888889
                },
                {
                    "id": "3",
                    "bfID": "14Gam Lyr",
                    "RAh": 18.98238889,
                    "DEd": 32.68944444
                },
                {
                    "id": "4",
                    "bfID": "10Bet Lyr",
                    "RAh": 18.83466667,
                    "DEd": 33.36277778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    1
                ]
            ]
        },
        {
            "Name": "Cassiopeia",
            "RAh": 1,
            "DEd": 60,
            "stars": [
                {
                    "id": "0",
                    "bfID": "11Bet Cas",
                    "RAh": 0.152972222,
                    "DEd": 59.14972222
                },
                {
                    "id": "1",
                    "bfID": "18Alp Cas",
                    "RAh": 0.675138889,
                    "DEd": 56.53722222
                },
                {
                    "id": "2",
                    "bfID": "27Gam Cas",
                    "RAh": 0.945138889,
                    "DEd": 60.71666667
                },
                {
                    "id": "3",
                    "bfID": "37Del Cas",
                    "RAh": 1.430277778,
                    "DEd": 60.23527778
                },
                {
                    "id": "4",
                    "bfID": "45Eps Cas",
                    "RAh": 1.906583333,
                    "DEd": 63.67
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ]
            ]
        },
        {
            "Name": "Aquila",
            "RAh": 20,
            "DEd": 5,
            "stars": [
                {
                    "id": "0",
                    "bfID": "60Bet Aql",
                    "RAh": 19.92188889,
                    "DEd": 6.406666667
                },
                {
                    "id": "1",
                    "bfID": "53Alp Aql",
                    "RAh": 19.84638889,
                    "DEd": 8.868333333
                },
                {
                    "id": "2",
                    "bfID": "50Gam Aql",
                    "RAh": 19.771,
                    "DEd": 10.61333333
                },
                {
                    "id": "3",
                    "bfID": "38Mu Aql",
                    "RAh": 19.56816667,
                    "DEd": 7.378888889
                },
                {
                    "id": "4",
                    "bfID": "30Del Aql",
                    "RAh": 19.42497222,
                    "DEd": 3.114722222
                },
                {
                    "id": "5",
                    "bfID": "16Lam Aql",
                    "RAh": 19.10413889,
                    "DEd": -4.8825
                },
                {
                    "id": "6",
                    "bfID": "12 Aql",
                    "RAh": 19.028,
                    "DEd": -5.738888889
                },
                {
                    "id": "7",
                    "bfID": "55Eta Aql",
                    "RAh": 19.87455556,
                    "DEd": 1.005555556
                },
                {
                    "id": "8",
                    "bfID": "65The Aql",
                    "RAh": 20.18841667,
                    "DEd": -0.821388889
                },
                {
                    "id": "9",
                    "bfID": "17Zet Aql",
                    "RAh": 19.09016667,
                    "DEd": 13.86333333
                },
                {
                    "id": "10",
                    "bfID": "13Eps Aql",
                    "RAh": 18.99372222,
                    "DEd": 15.06833333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    4,
                    7
                ],
                [
                    7,
                    8
                ],
                [
                    4,
                    9
                ],
                [
                    9,
                    10
                ]
            ]
        },
        {
            "Name": "Scorpio",
            "RAh": 17,
            "DEd": -40,
            "stars": [
                {
                    "id": "0",
                    "bfID": "7Del Sco",
                    "RAh": 16.00555556,
                    "DEd": -22.62166667
                },
                {
                    "id": "1",
                    "bfID": "8Bet1Sco",
                    "RAh": 16.09061111,
                    "DEd": -19.80555556
                },
                {
                    "id": "2",
                    "bfID": "6Pi Sco",
                    "RAh": 15.98086111,
                    "DEd": -26.11416667
                },
                {
                    "id": "3",
                    "bfID": "21Alp Sco",
                    "RAh": 16.49011111,
                    "DEd": -26.43194444
                },
                {
                    "id": "4",
                    "bfID": "23Tau Sco",
                    "RAh": 16.59805556,
                    "DEd": -28.21611111
                },
                {
                    "id": "5",
                    "bfID": "26Eps Sco",
                    "RAh": 16.83605556,
                    "DEd": -34.29333333
                },
                {
                    "id": "6",
                    "bfID": "Mu 1Sco",
                    "RAh": 16.8645,
                    "DEd": -38.0475
                },
                {
                    "id": "7",
                    "bfID": "Zet2Sco",
                    "RAh": 16.90972222,
                    "DEd": -42.36138889
                },
                {
                    "id": "8",
                    "bfID": "Eta Sco",
                    "RAh": 17.20255556,
                    "DEd": -43.23916667
                },
                {
                    "id": "9",
                    "bfID": "The Sco",
                    "RAh": 17.622,
                    "DEd": -42.99777778
                },
                {
                    "id": "10",
                    "bfID": "Iot1Sco",
                    "RAh": 17.79308333,
                    "DEd": -40.12694444
                },
                {
                    "id": "11",
                    "bfID": "Kap Sco",
                    "RAh": 17.70813889,
                    "DEd": -39.03
                },
                {
                    "id": "12",
                    "bfID": "35Lam Sco",
                    "RAh": 17.56013889,
                    "DEd": -37.10388889
                },
                {
                    "id": "13",
                    "bfID": "34Ups Sco",
                    "RAh": 17.51272222,
                    "DEd": -37.29583333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    0,
                    2
                ],
                [
                    3,
                    0
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    6,
                    7
                ],
                [
                    7,
                    8
                ],
                [
                    8,
                    9
                ],
                [
                    9,
                    10
                ],
                [
                    10,
                    11
                ],
                [
                    11,
                    12
                ],
                [
                    12,
                    13
                ]
            ]
        },
        {
            "Name": "Libra",
            "RAh": 15,
            "DEd": -15,
            "stars": [
                {
                    "id": "0",
                    "bfID": "46The Lib",
                    "RAh": 15.89708333,
                    "DEd": -16.72944444
                },
                {
                    "id": "1",
                    "bfID": "38Gam Lib",
                    "RAh": 15.59211111,
                    "DEd": -14.78944444
                },
                {
                    "id": "2",
                    "bfID": "27Bet Lib",
                    "RAh": 15.28344444,
                    "DEd": -9.383055556
                },
                {
                    "id": "3",
                    "bfID": "9Alp2Lib",
                    "RAh": 14.84797222,
                    "DEd": -16.04166667
                },
                {
                    "id": "4",
                    "bfID": "20Sig Lib",
                    "RAh": 15.06783333,
                    "DEd": -25.28194444
                },
                {
                    "id": "5",
                    "bfID": "39Ups Lib",
                    "RAh": 15.61708333,
                    "DEd": -28.135
                },
                {
                    "id": "6",
                    "bfID": "40Tau Lib",
                    "RAh": 15.64427778,
                    "DEd": -29.77777778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ]
            ]
        },
        {
            "Name": "Gemini",
            "RAh": 7,
            "DEd": 20,
            "stars": [
                {
                    "id": "0",
                    "bfID": "24Gam Gem",
                    "RAh": 6.628527778,
                    "DEd": 16.39916667
                },
                {
                    "id": "1",
                    "bfID": "43Zet Gem",
                    "RAh": 7.068472222,
                    "DEd": 20.57027778
                },
                {
                    "id": "2",
                    "bfID": "55Del Gem",
                    "RAh": 7.335388889,
                    "DEd": 21.98222222
                },
                {
                    "id": "3",
                    "bfID": "78Bet Gem",
                    "RAh": 7.75525,
                    "DEd": 28.02611111
                },
                {
                    "id": "4",
                    "bfID": "66Alp Gem",
                    "RAh": 7.576666667,
                    "DEd": 31.88833333
                },
                {
                    "id": "5",
                    "bfID": "27Eps Gem",
                    "RAh": 6.732194444,
                    "DEd": 25.13111111
                },
                {
                    "id": "6",
                    "bfID": "13Mu Gem",
                    "RAh": 6.382666667,
                    "DEd": 22.51361111
                },
                {
                    "id": "7",
                    "bfID": "7Eta Gem",
                    "RAh": 6.247944444,
                    "DEd": 22.50666667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Leo",
            "RAh": 11,
            "DEd": 15,
            "stars": [
                {
                    "id": "0",
                    "bfID": "17Eps Leo",
                    "RAh": 9.764194444,
                    "DEd": 23.77416667
                },
                {
                    "id": "1",
                    "bfID": "24Mu Leo",
                    "RAh": 9.879388889,
                    "DEd": 26.00694444
                },
                {
                    "id": "2",
                    "bfID": "36Zet Leo",
                    "RAh": 10.27816667,
                    "DEd": 23.41722222
                },
                {
                    "id": "3",
                    "bfID": "41Gam1Leo",
                    "RAh": 10.33286111,
                    "DEd": 19.84166667
                },
                {
                    "id": "4",
                    "bfID": "30Eta Leo",
                    "RAh": 10.12222222,
                    "DEd": 16.76277778
                },
                {
                    "id": "5",
                    "bfID": "32Alp Leo",
                    "RAh": 10.13952778,
                    "DEd": 11.96722222
                },
                {
                    "id": "6",
                    "bfID": "70The Leo",
                    "RAh": 11.23733333,
                    "DEd": 15.42944444
                },
                {
                    "id": "7",
                    "bfID": "94Bet Leo",
                    "RAh": 11.81766667,
                    "DEd": 14.57194444
                },
                {
                    "id": "8",
                    "bfID": "68Del Leo",
                    "RAh": 11.23513889,
                    "DEd": 20.52361111
                },
                {
                    "id": "9",
                    "bfID": "41Gam2Leo",
                    "RAh": 10.33294444,
                    "DEd": 19.84055556
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    6,
                    7
                ],
                [
                    7,
                    8
                ],
                [
                    8,
                    6
                ],
                [
                    8,
                    3
                ]
            ]
        },
        {
            "Name": "Perseus",
            "RAh": 3,
            "DEd": 45,
            "stars": [
                {
                    "id": "0",
                    "bfID": "38Omi Per",
                    "RAh": 3.738638889,
                    "DEd": 32.28833333
                },
                {
                    "id": "1",
                    "bfID": "44Zet Per",
                    "RAh": 3.902194444,
                    "DEd": 31.88361111
                },
                {
                    "id": "2",
                    "bfID": "46Xi Per",
                    "RAh": 3.98275,
                    "DEd": 35.79111111
                },
                {
                    "id": "3",
                    "bfID": "45Eps Per",
                    "RAh": 3.964222222,
                    "DEd": 40.01027778
                },
                {
                    "id": "4",
                    "bfID": "39Del Per",
                    "RAh": 3.715416667,
                    "DEd": 47.7875
                },
                {
                    "id": "5",
                    "bfID": "33Alp Per",
                    "RAh": 3.405388889,
                    "DEd": 49.86111111
                },
                {
                    "id": "6",
                    "bfID": "23Gam Per",
                    "RAh": 3.079944444,
                    "DEd": 53.50638889
                },
                {
                    "id": "7",
                    "bfID": "15Eta Per",
                    "RAh": 2.844944444,
                    "DEd": 55.89555556
                },
                {
                    "id": "8",
                    "bfID": "26Bet Per",
                    "RAh": 3.136138889,
                    "DEd": 40.95555556
                },
                {
                    "id": "9",
                    "bfID": "25Rho Per",
                    "RAh": 3.086277778,
                    "DEd": 38.84027778
                },
                {
                    "id": "10",
                    "bfID": "16 Per",
                    "RAh": 2.843083333,
                    "DEd": 38.31861111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    6,
                    7
                ],
                [
                    4,
                    8
                ],
                [
                    8,
                    9
                ],
                [
                    9,
                    10
                ]
            ]
        },
        {
            "Name": "Virgo",
            "RAh": 13,
            "DEd": 0,
            "stars": [
                {
                    "id": "0",
                    "bfID": "3Nu Vir",
                    "RAh": 11.76433333,
                    "DEd": 6.529444444
                },
                {
                    "id": "1",
                    "bfID": "15Eta Vir",
                    "RAh": 12.33177778,
                    "DEd": -0.666944444
                },
                {
                    "id": "2",
                    "bfID": "29Gam Vir",
                    "RAh": 12.69433333,
                    "DEd": -1.449444444
                },
                {
                    "id": "3",
                    "bfID": "67Alp Vir",
                    "RAh": 13.41988889,
                    "DEd": -11.16138889
                },
                {
                    "id": "4",
                    "bfID": "98Kap Vir",
                    "RAh": 14.21494444,
                    "DEd": -10.27361111
                },
                {
                    "id": "5",
                    "bfID": "99Iot Vir",
                    "RAh": 14.26691667,
                    "DEd": -6.000555556
                },
                {
                    "id": "6",
                    "bfID": "107Mu Vir",
                    "RAh": 14.71766667,
                    "DEd": -5.658333333
                },
                {
                    "id": "7",
                    "bfID": "79Zet Vir",
                    "RAh": 13.57822222,
                    "DEd": -0.595833333
                },
                {
                    "id": "8",
                    "bfID": "93Tau Vir",
                    "RAh": 14.02744444,
                    "DEd": 1.544444444
                },
                {
                    "id": "9",
                    "bfID": "109 Vir",
                    "RAh": 14.77080556,
                    "DEd": 1.892777778
                },
                {
                    "id": "10",
                    "bfID": "43Del Vir",
                    "RAh": 12.92672222,
                    "DEd": 3.3975
                },
                {
                    "id": "11",
                    "bfID": "47Eps Vir",
                    "RAh": 13.03627778,
                    "DEd": 10.95916667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    3,
                    7
                ],
                [
                    7,
                    8
                ],
                [
                    8,
                    9
                ],
                [
                    7,
                    10
                ],
                [
                    10,
                    11
                ],
                [
                    10,
                    2
                ]
            ]
        },
        {
            "Name": "Hercules",
            "RAh": 17,
            "DEd": 30,
            "stars": [
                {
                    "id": "0",
                    "bfID": "40Zet Her",
                    "RAh": 16.68811111,
                    "DEd": 31.60305556
                },
                {
                    "id": "1",
                    "bfID": "27Bet Her",
                    "RAh": 16.50366667,
                    "DEd": 21.48972222
                },
                {
                    "id": "2",
                    "bfID": "20Gam Her",
                    "RAh": 16.36533333,
                    "DEd": 19.15305556
                },
                {
                    "id": "3",
                    "bfID": "58Eps Her",
                    "RAh": 17.00483333,
                    "DEd": 30.92638889
                },
                {
                    "id": "4",
                    "bfID": "65Del Her",
                    "RAh": 17.25052778,
                    "DEd": 24.83916667
                },
                {
                    "id": "5",
                    "bfID": "76Lam Her",
                    "RAh": 17.51230556,
                    "DEd": 26.11055556
                },
                {
                    "id": "6",
                    "bfID": "86Mu Her",
                    "RAh": 17.77430556,
                    "DEd": 27.72055556
                },
                {
                    "id": "7",
                    "bfID": "92Xi Her",
                    "RAh": 17.96275,
                    "DEd": 29.24777778
                },
                {
                    "id": "8",
                    "bfID": "103Omi Her",
                    "RAh": 18.12572222,
                    "DEd": 28.7625
                },
                {
                    "id": "9",
                    "bfID": "67Pi Her",
                    "RAh": 17.25077778,
                    "DEd": 36.80916667
                },
                {
                    "id": "10",
                    "bfID": "75Rho Her",
                    "RAh": 17.39472222,
                    "DEd": 37.14583333
                },
                {
                    "id": "11",
                    "bfID": "91The Her",
                    "RAh": 17.93755556,
                    "DEd": 37.25055556
                },
                {
                    "id": "12",
                    "bfID": "85Iot Her",
                    "RAh": 17.65775,
                    "DEd": 46.00638889
                },
                {
                    "id": "13",
                    "bfID": "44Eta Her",
                    "RAh": 16.71494444,
                    "DEd": 38.92222222
                },
                {
                    "id": "14",
                    "bfID": "35Sig Her",
                    "RAh": 16.56838889,
                    "DEd": 42.43694444
                },
                {
                    "id": "15",
                    "bfID": "22Tau Her",
                    "RAh": 16.329,
                    "DEd": 46.31333333
                },
                {
                    "id": "16",
                    "bfID": "11Phi Her",
                    "RAh": 16.14616667,
                    "DEd": 44.935
                },
                {
                    "id": "17",
                    "bfID": "1Chi Her",
                    "RAh": 15.87791667,
                    "DEd": 42.45166667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    0,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    4,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    6,
                    7
                ],
                [
                    7,
                    8
                ],
                [
                    3,
                    9
                ],
                [
                    9,
                    10
                ],
                [
                    10,
                    11
                ],
                [
                    11,
                    12
                ],
                [
                    9,
                    13
                ],
                [
                    13,
                    14
                ],
                [
                    14,
                    15
                ],
                [
                    15,
                    16
                ],
                [
                    16,
                    17
                ],
                [
                    13,
                    0
                ]
            ]
        },
        {
            "Name": "Coma Berenices",
            "RAh": "13.19788889",
            "DEd": "27.87805556",
            "stars": [
                {
                    "id": 0,
                    "bfID": "42Alp Com",
                    "RAh": 13.16647222,
                    "DEd": 17.52944444
                },
                {
                    "id": 1,
                    "bfID": "43Bet Com",
                    "RAh": 13.19788889,
                    "DEd": 27.87805556
                },
                {
                    "id": 2,
                    "bfID": "15Gam Com",
                    "RAh": 12.44897222,
                    "DEd": 28.26833333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ]
            ]
        },
        {
            "Name": "Canes Venatici",
            "RAh": "12.56236111",
            "DEd": "41.3575",
            "stars": [
                {
                    "id": 0,
                    "bfID": "8Bet CVn",
                    "RAh": 12.56236111,
                    "DEd": 41.3575
                },
                {
                    "id": 1,
                    "bfID": "12Alp2CVn",
                    "RAh": 12.93380556,
                    "DEd": 38.31833333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ]
            ]
        },
        {
            "Name": "Crater",
            "RAh": "10.99625",
            "DEd": "-18.29888889",
            "stars": [
                {
                    "id": 0,
                    "bfID": "7Alp Crt",
                    "RAh": 10.99625,
                    "DEd": -18.29888889
                },
                {
                    "id": 1,
                    "bfID": "11Bet Crt",
                    "RAh": 11.19430556,
                    "DEd": -22.82583333
                },
                {
                    "id": 2,
                    "bfID": "15Gam Crt",
                    "RAh": 11.41469444,
                    "DEd": -17.68388889
                },
                {
                    "id": 3,
                    "bfID": "12Del Crt",
                    "RAh": 11.32236111,
                    "DEd": -14.77861111
                },
                {
                    "id": 4,
                    "bfID": "7Alp Crt",
                    "RAh": 10.99625,
                    "DEd": -18.29888889
                },
                {
                    "id": 5,
                    "bfID": "14Eps Crt",
                    "RAh": 11.41016667,
                    "DEd": -10.85944444
                },
                {
                    "id": 6,
                    "bfID": "21The Crt",
                    "RAh": 11.61136111,
                    "DEd": -9.802222222
                },
                {
                    "id": 7,
                    "bfID": "30Eta Crt",
                    "RAh": 11.93358333,
                    "DEd": -17.15083333
                },
                {
                    "id": 8,
                    "bfID": "27Zet Crt",
                    "RAh": 11.74605556,
                    "DEd": -18.35083333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    3,
                    5
                ],
                [
                    5,
                    6
                ],
                [
                    6,
                    7
                ],
                [
                    7,
                    8
                ],
                [
                    8,
                    2
                ]
            ]
        },
        {
            "Name": "Canis Minor",
            "RAh": "7.4525",
            "DEd": "8.289444444",
            "stars": [
                {
                    "id": 0,
                    "bfID": "10Alp CMi",
                    "RAh": 7.655027778,
                    "DEd": 5.225
                },
                {
                    "id": 1,
                    "bfID": "3Bet CMi",
                    "RAh": 7.4525,
                    "DEd": 8.289444444
                }
            ],
            "lines": [
                [
                    0,
                    1
                ]
            ]
        },
        {
            "Name": "Caelum",
            "RAh": "4.513916667",
            "DEd": "-44.95388889",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Del Cae",
                    "RAh": 4.513916667,
                    "DEd": -44.95388889
                },
                {
                    "id": 1,
                    "bfID": "Alp Cae",
                    "RAh": 4.676027778,
                    "DEd": -41.86388889
                },
                {
                    "id": 2,
                    "bfID": "Bet Cae",
                    "RAh": 4.700972222,
                    "DEd": -37.14444444
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ]
            ]
        },
        {
            "Name": "Chamaeleon",
            "RAh": "8.308777778",
            "DEd": "-76.91972222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Cha",
                    "RAh": 8.308777778,
                    "DEd": -76.91972222
                },
                {
                    "id": 1,
                    "bfID": "Gam Cha",
                    "RAh": 10.59113889,
                    "DEd": -78.60777778
                },
                {
                    "id": 2,
                    "bfID": "Bet Cha",
                    "RAh": 12.30575,
                    "DEd": -79.31222222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ]
            ]
        },
        {
            "Name": "Cancer",
            "RAh": "8.778277778",
            "DEd": "28.76",
            "stars": [
                {
                    "id": 0,
                    "bfID": "48Iot Cnc",
                    "RAh": 8.778277778,
                    "DEd": 28.76
                },
                {
                    "id": 1,
                    "bfID": "43Gam Cnc",
                    "RAh": 8.721416667,
                    "DEd": 21.46861111
                },
                {
                    "id": 2,
                    "bfID": "18Chi Cnc",
                    "RAh": 8.334416667,
                    "DEd": 27.21777778
                },
                {
                    "id": 3,
                    "bfID": "47Del Cnc",
                    "RAh": 8.74475,
                    "DEd": 18.15416667
                },
                {
                    "id": 4,
                    "bfID": "17Bet Cnc",
                    "RAh": 8.27525,
                    "DEd": 9.185555556
                },
                {
                    "id": 5,
                    "bfID": "65Alp Cnc",
                    "RAh": 8.974777778,
                    "DEd": 11.85777778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    1,
                    3
                ],
                [
                    3,
                    4
                ],
                [
                    3,
                    5
                ]
            ]
        },
        {
            "Name": "Sculptor",
            "RAh": "23.54952778",
            "DEd": "-37.81833333",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Bet Scl",
                    "RAh": 23.54952778,
                    "DEd": -37.81833333
                },
                {
                    "id": 1,
                    "bfID": "Alp Scl",
                    "RAh": 0.976777778,
                    "DEd": -29.3575
                },
                {
                    "id": 2,
                    "bfID": "Alp Scl",
                    "RAh": 0.976777778,
                    "DEd": -29.3575
                },
                {
                    "id": 3,
                    "bfID": "Gam Scl",
                    "RAh": 23.31372222,
                    "DEd": -32.53194444
                },
                {
                    "id": 4,
                    "bfID": "Gam Scl",
                    "RAh": 23.31372222,
                    "DEd": -32.53194444
                },
                {
                    "id": 5,
                    "bfID": "Bet Scl",
                    "RAh": 23.54952778,
                    "DEd": -37.81833333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ]
            ]
        },
        {
            "Name": "Ara",
            "RAh": "18.11052778",
            "DEd": "-50.09166667",
            "stars": [
                {
                    "id": 0,
                    "bfID": "The Ara",
                    "RAh": 18.11052778,
                    "DEd": -50.09166667
                },
                {
                    "id": 1,
                    "bfID": "Alp Ara",
                    "RAh": 17.53069444,
                    "DEd": -49.87611111
                },
                {
                    "id": 2,
                    "bfID": "Alp Ara",
                    "RAh": 17.53069444,
                    "DEd": -49.87611111
                },
                {
                    "id": 3,
                    "bfID": "Zet Ara",
                    "RAh": 16.977,
                    "DEd": -55.99027778
                },
                {
                    "id": 4,
                    "bfID": "Zet Ara",
                    "RAh": 16.977,
                    "DEd": -55.99027778
                },
                {
                    "id": 5,
                    "bfID": "Eta Ara",
                    "RAh": 16.82975,
                    "DEd": -59.04138889
                },
                {
                    "id": 6,
                    "bfID": "Eta Ara",
                    "RAh": 16.82975,
                    "DEd": -59.04138889
                },
                {
                    "id": 7,
                    "bfID": "Del Ara",
                    "RAh": 17.51830556,
                    "DEd": -60.68388889
                },
                {
                    "id": 8,
                    "bfID": "Del Ara",
                    "RAh": 17.51830556,
                    "DEd": -60.68388889
                },
                {
                    "id": 9,
                    "bfID": "Gam Ara",
                    "RAh": 17.42322222,
                    "DEd": -56.3775
                },
                {
                    "id": 10,
                    "bfID": "Gam Ara",
                    "RAh": 17.42322222,
                    "DEd": -56.3775
                },
                {
                    "id": 11,
                    "bfID": "Bet Ara",
                    "RAh": 17.42166667,
                    "DEd": -55.53
                },
                {
                    "id": 12,
                    "bfID": "Bet Ara",
                    "RAh": 17.42166667,
                    "DEd": -55.53
                },
                {
                    "id": 13,
                    "bfID": "The Ara",
                    "RAh": 18.11052778,
                    "DEd": -50.09166667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ]
            ]
        },
        {
            "Name": "Cetus",
            "RAh": "2.216666667",
            "DEd": "8.846666667",
            "stars": [
                {
                    "id": 0,
                    "bfID": "65Xi 1Cet",
                    "RAh": 2.216666667,
                    "DEd": 8.846666667
                },
                {
                    "id": 1,
                    "bfID": "73Xi 2Cet",
                    "RAh": 2.469305556,
                    "DEd": 8.46
                },
                {
                    "id": 2,
                    "bfID": "52Tau Cet",
                    "RAh": 1.734472222,
                    "DEd": -15.9375
                },
                {
                    "id": 3,
                    "bfID": "16Bet Cet",
                    "RAh": 0.7265,
                    "DEd": -17.98666667
                },
                {
                    "id": 4,
                    "bfID": "16Bet Cet",
                    "RAh": 0.7265,
                    "DEd": -17.98666667
                },
                {
                    "id": 5,
                    "bfID": "8Iot Cet",
                    "RAh": 0.323805556,
                    "DEd": -8.823888889
                },
                {
                    "id": 6,
                    "bfID": "16Bet Cet",
                    "RAh": 0.7265,
                    "DEd": -17.98666667
                },
                {
                    "id": 7,
                    "bfID": "31Eta Cet",
                    "RAh": 1.143166667,
                    "DEd": -10.18222222
                },
                {
                    "id": 8,
                    "bfID": "31Eta Cet",
                    "RAh": 1.143166667,
                    "DEd": -10.18222222
                },
                {
                    "id": 9,
                    "bfID": "45The Cet",
                    "RAh": 1.400388889,
                    "DEd": -8.183333333
                },
                {
                    "id": 10,
                    "bfID": "45The Cet",
                    "RAh": 1.400388889,
                    "DEd": -8.183333333
                },
                {
                    "id": 11,
                    "bfID": "55Zet Cet",
                    "RAh": 1.857666667,
                    "DEd": -10.335
                },
                {
                    "id": 12,
                    "bfID": "55Zet Cet",
                    "RAh": 1.857666667,
                    "DEd": -10.335
                },
                {
                    "id": 13,
                    "bfID": "72Rho Cet",
                    "RAh": 2.4325,
                    "DEd": -12.29055556
                },
                {
                    "id": 14,
                    "bfID": "72Rho Cet",
                    "RAh": 2.4325,
                    "DEd": -12.29055556
                },
                {
                    "id": 15,
                    "bfID": "83Eps Cet",
                    "RAh": 2.659388889,
                    "DEd": -11.87222222
                },
                {
                    "id": 16,
                    "bfID": "83Eps Cet",
                    "RAh": 2.659388889,
                    "DEd": -11.87222222
                },
                {
                    "id": 17,
                    "bfID": "89Pi Cet",
                    "RAh": 2.735388889,
                    "DEd": -13.85861111
                },
                {
                    "id": 18,
                    "bfID": "89Pi Cet",
                    "RAh": 2.735388889,
                    "DEd": -13.85861111
                },
                {
                    "id": 19,
                    "bfID": "76Sig Cet",
                    "RAh": 2.534777778,
                    "DEd": -15.24472222
                },
                {
                    "id": 20,
                    "bfID": "76Sig Cet",
                    "RAh": 2.534777778,
                    "DEd": -15.24472222
                },
                {
                    "id": 21,
                    "bfID": "52Tau Cet",
                    "RAh": 1.734472222,
                    "DEd": -15.9375
                },
                {
                    "id": 22,
                    "bfID": "68Omi Cet",
                    "RAh": 2.322416667,
                    "DEd": -2.9775
                },
                {
                    "id": 23,
                    "bfID": "83Eps Cet",
                    "RAh": 2.659388889,
                    "DEd": -11.87222222
                },
                {
                    "id": 24,
                    "bfID": "68Omi Cet",
                    "RAh": 2.322416667,
                    "DEd": -2.9775
                },
                {
                    "id": 25,
                    "bfID": "82Del Cet",
                    "RAh": 2.658055556,
                    "DEd": 0.328611111
                },
                {
                    "id": 26,
                    "bfID": "82Del Cet",
                    "RAh": 2.658055556,
                    "DEd": 0.328611111
                },
                {
                    "id": 27,
                    "bfID": "86Gam Cet",
                    "RAh": 2.721666667,
                    "DEd": 3.235833333
                },
                {
                    "id": 28,
                    "bfID": "86Gam Cet",
                    "RAh": 2.721666667,
                    "DEd": 3.235833333
                },
                {
                    "id": 29,
                    "bfID": "93 Cet",
                    "RAh": 3.039583333,
                    "DEd": 4.352777778
                },
                {
                    "id": 30,
                    "bfID": "93 Cet",
                    "RAh": 3.039583333,
                    "DEd": 4.352777778
                },
                {
                    "id": 31,
                    "bfID": "91Lam Cet",
                    "RAh": 2.99525,
                    "DEd": 8.9075
                },
                {
                    "id": 32,
                    "bfID": "91Lam Cet",
                    "RAh": 2.99525,
                    "DEd": 8.9075
                },
                {
                    "id": 33,
                    "bfID": "87Mu Cet",
                    "RAh": 2.749027778,
                    "DEd": 10.11416667
                },
                {
                    "id": 34,
                    "bfID": "87Mu Cet",
                    "RAh": 2.749027778,
                    "DEd": 10.11416667
                },
                {
                    "id": 35,
                    "bfID": "73Xi 2Cet",
                    "RAh": 2.469305556,
                    "DEd": 8.46
                },
                {
                    "id": 36,
                    "bfID": "73Xi 2Cet",
                    "RAh": 2.469305556,
                    "DEd": 8.46
                },
                {
                    "id": 37,
                    "bfID": "78Nu Cet",
                    "RAh": 2.597916667,
                    "DEd": 5.593333333
                },
                {
                    "id": 38,
                    "bfID": "78Nu Cet",
                    "RAh": 2.597916667,
                    "DEd": 5.593333333
                },
                {
                    "id": 39,
                    "bfID": "86Gam Cet",
                    "RAh": 2.721666667,
                    "DEd": 3.235833333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ],
                [
                    28,
                    29
                ],
                [
                    30,
                    31
                ],
                [
                    32,
                    33
                ],
                [
                    34,
                    35
                ],
                [
                    36,
                    37
                ],
                [
                    38,
                    39
                ]
            ]
        },
        {
            "Name": "Aries",
            "RAh": "2.833055556",
            "DEd": "27.26055556",
            "stars": [
                {
                    "id": 0,
                    "bfID": "41 Ari",
                    "RAh": 2.833055556,
                    "DEd": 27.26055556
                },
                {
                    "id": 1,
                    "bfID": "13Alp Ari",
                    "RAh": 2.119555556,
                    "DEd": 23.4625
                },
                {
                    "id": 2,
                    "bfID": "13Alp Ari",
                    "RAh": 2.119555556,
                    "DEd": 23.4625
                },
                {
                    "id": 3,
                    "bfID": "6Bet Ari",
                    "RAh": 1.910666667,
                    "DEd": 20.80805556
                },
                {
                    "id": 4,
                    "bfID": "6Bet Ari",
                    "RAh": 1.910666667,
                    "DEd": 20.80805556
                },
                {
                    "id": 5,
                    "bfID": "5Gam2Ari",
                    "RAh": 1.892166667,
                    "DEd": 19.29361111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ]
            ]
        },
        {
            "Name": "Pyxis",
            "RAh": "8.668388889",
            "DEd": "-35.30833333",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Bet Pyx",
                    "RAh": 8.668388889,
                    "DEd": -35.30833333
                },
                {
                    "id": 1,
                    "bfID": "Alp Pyx",
                    "RAh": 8.726527778,
                    "DEd": -33.18638889
                },
                {
                    "id": 2,
                    "bfID": "Alp Pyx",
                    "RAh": 8.726527778,
                    "DEd": -33.18638889
                },
                {
                    "id": 3,
                    "bfID": "Gam Pyx",
                    "RAh": 8.842194444,
                    "DEd": -27.71
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ]
            ]
        },
        {
            "Name": "Bootes",
            "RAh": "14.68580556",
            "DEd": "13.72833333",
            "stars": [
                {
                    "id": 0,
                    "bfID": "30Zet Boo",
                    "RAh": 14.68580556,
                    "DEd": 13.72833333
                },
                {
                    "id": 1,
                    "bfID": "16Alp Boo",
                    "RAh": 14.26102778,
                    "DEd": 19.1825
                },
                {
                    "id": 2,
                    "bfID": "16Alp Boo",
                    "RAh": 14.26102778,
                    "DEd": 19.1825
                },
                {
                    "id": 3,
                    "bfID": "36Eps Boo",
                    "RAh": 14.74977778,
                    "DEd": 27.075
                },
                {
                    "id": 4,
                    "bfID": "36Eps Boo",
                    "RAh": 14.74977778,
                    "DEd": 27.075
                },
                {
                    "id": 5,
                    "bfID": "49Del Boo",
                    "RAh": 15.25838889,
                    "DEd": 33.31472222
                },
                {
                    "id": 6,
                    "bfID": "49Del Boo",
                    "RAh": 15.25838889,
                    "DEd": 33.31472222
                },
                {
                    "id": 7,
                    "bfID": "42Bet Boo",
                    "RAh": 15.03244444,
                    "DEd": 40.39055556
                },
                {
                    "id": 8,
                    "bfID": "42Bet Boo",
                    "RAh": 15.03244444,
                    "DEd": 40.39055556
                },
                {
                    "id": 9,
                    "bfID": "27Gam Boo",
                    "RAh": 14.53463889,
                    "DEd": 38.30833333
                },
                {
                    "id": 10,
                    "bfID": "27Gam Boo",
                    "RAh": 14.53463889,
                    "DEd": 38.30833333
                },
                {
                    "id": 11,
                    "bfID": "25Rho Boo",
                    "RAh": 14.5305,
                    "DEd": 30.37138889
                },
                {
                    "id": 12,
                    "bfID": "25Rho Boo",
                    "RAh": 14.5305,
                    "DEd": 30.37138889
                },
                {
                    "id": 13,
                    "bfID": "16Alp Boo",
                    "RAh": 14.26102778,
                    "DEd": 19.1825
                },
                {
                    "id": 14,
                    "bfID": "16Alp Boo",
                    "RAh": 14.26102778,
                    "DEd": 19.1825
                },
                {
                    "id": 15,
                    "bfID": "8Eta Boo",
                    "RAh": 13.91141667,
                    "DEd": 18.39777778
                },
                {
                    "id": 16,
                    "bfID": "8Eta Boo",
                    "RAh": 13.91141667,
                    "DEd": 18.39777778
                },
                {
                    "id": 17,
                    "bfID": "5Ups Boo",
                    "RAh": 13.82461111,
                    "DEd": 15.79777778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ]
            ]
        },
        {
            "Name": "Capricornus",
            "RAh": "20.30091667",
            "DEd": "-12.54472222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "6Alp2Cap",
                    "RAh": 20.30091667,
                    "DEd": -12.54472222
                },
                {
                    "id": 1,
                    "bfID": "9Bet Cap",
                    "RAh": 20.35019444,
                    "DEd": -14.78138889
                },
                {
                    "id": 2,
                    "bfID": "9Bet Cap",
                    "RAh": 20.35019444,
                    "DEd": -14.78138889
                },
                {
                    "id": 3,
                    "bfID": "23The Cap",
                    "RAh": 21.09911111,
                    "DEd": -17.23277778
                },
                {
                    "id": 4,
                    "bfID": "23The Cap",
                    "RAh": 21.09911111,
                    "DEd": -17.23277778
                },
                {
                    "id": 5,
                    "bfID": "32Iot Cap",
                    "RAh": 21.37077778,
                    "DEd": -16.83444444
                },
                {
                    "id": 6,
                    "bfID": "32Iot Cap",
                    "RAh": 21.37077778,
                    "DEd": -16.83444444
                },
                {
                    "id": 7,
                    "bfID": "40Gam Cap",
                    "RAh": 21.66819444,
                    "DEd": -16.66222222
                },
                {
                    "id": 8,
                    "bfID": "40Gam Cap",
                    "RAh": 21.66819444,
                    "DEd": -16.66222222
                },
                {
                    "id": 9,
                    "bfID": "49Del Cap",
                    "RAh": 21.784,
                    "DEd": -16.12722222
                },
                {
                    "id": 10,
                    "bfID": "32Iot Cap",
                    "RAh": 21.37077778,
                    "DEd": -16.83444444
                },
                {
                    "id": 11,
                    "bfID": "34Zet Cap",
                    "RAh": 21.44444444,
                    "DEd": -22.41138889
                },
                {
                    "id": 12,
                    "bfID": "34Zet Cap",
                    "RAh": 21.44444444,
                    "DEd": -22.41138889
                },
                {
                    "id": 13,
                    "bfID": "23The Cap",
                    "RAh": 21.09911111,
                    "DEd": -17.23277778
                },
                {
                    "id": 14,
                    "bfID": "9Bet Cap",
                    "RAh": 20.35019444,
                    "DEd": -14.78138889
                },
                {
                    "id": 15,
                    "bfID": "16Psi Cap",
                    "RAh": 20.76825,
                    "DEd": -25.27083333
                },
                {
                    "id": 16,
                    "bfID": "23The Cap",
                    "RAh": 21.09911111,
                    "DEd": -17.23277778
                },
                {
                    "id": 17,
                    "bfID": "18Ome Cap",
                    "RAh": 20.86369444,
                    "DEd": -26.91916667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ]
            ]
        },
        {
            "Name": "Cepheus",
            "RAh": "22.18091667",
            "DEd": "58.20111111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "21Zet Cep",
                    "RAh": 22.18091667,
                    "DEd": 58.20111111
                },
                {
                    "id": 1,
                    "bfID": "32Iot Cep",
                    "RAh": 22.828,
                    "DEd": 66.20055556
                },
                {
                    "id": 2,
                    "bfID": "32Iot Cep",
                    "RAh": 22.828,
                    "DEd": 66.20055556
                },
                {
                    "id": 3,
                    "bfID": "8Bet Cep",
                    "RAh": 21.47766667,
                    "DEd": 70.56083333
                },
                {
                    "id": 4,
                    "bfID": "8Bet Cep",
                    "RAh": 21.47766667,
                    "DEd": 70.56083333
                },
                {
                    "id": 5,
                    "bfID": "5Alp Cep",
                    "RAh": 21.30966667,
                    "DEd": 62.58555556
                },
                {
                    "id": 6,
                    "bfID": "5Alp Cep",
                    "RAh": 21.30966667,
                    "DEd": 62.58555556
                },
                {
                    "id": 7,
                    "bfID": "21Zet Cep",
                    "RAh": 22.18091667,
                    "DEd": 58.20111111
                },
                {
                    "id": 8,
                    "bfID": "32Iot Cep",
                    "RAh": 22.828,
                    "DEd": 66.20055556
                },
                {
                    "id": 9,
                    "bfID": "35Gam Cep",
                    "RAh": 23.65577778,
                    "DEd": 77.6325
                },
                {
                    "id": 10,
                    "bfID": "35Gam Cep",
                    "RAh": 23.65577778,
                    "DEd": 77.6325
                },
                {
                    "id": 11,
                    "bfID": "8Bet Cep",
                    "RAh": 21.47766667,
                    "DEd": 70.56083333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ]
            ]
        },
        {
            "Name": "Auriga",
            "RAh": "5.995361111",
            "DEd": "37.2125",
            "stars": [
                {
                    "id": 0,
                    "bfID": "37The Aur",
                    "RAh": 5.995361111,
                    "DEd": 37.2125
                },
                {
                    "id": 1,
                    "bfID": "34Bet Aur",
                    "RAh": 5.992138889,
                    "DEd": 44.9475
                },
                {
                    "id": 2,
                    "bfID": "34Bet Aur",
                    "RAh": 5.992138889,
                    "DEd": 44.9475
                },
                {
                    "id": 3,
                    "bfID": "13Alp Aur",
                    "RAh": 5.278166667,
                    "DEd": 45.99805556
                },
                {
                    "id": 4,
                    "bfID": "13Alp Aur",
                    "RAh": 5.278166667,
                    "DEd": 45.99805556
                },
                {
                    "id": 5,
                    "bfID": "8Zet Aur",
                    "RAh": 5.041305556,
                    "DEd": 41.07583333
                },
                {
                    "id": 6,
                    "bfID": "8Zet Aur",
                    "RAh": 5.041305556,
                    "DEd": 41.07583333
                },
                {
                    "id": 7,
                    "bfID": "3Iot Aur",
                    "RAh": 4.949888889,
                    "DEd": 33.16611111
                },
                {
                    "id": 8,
                    "bfID": "112Bet Tau",
                    "RAh": 5.438194444,
                    "DEd": 28.6075
                },
                {
                    "id": 9,
                    "bfID": "3Iot Aur",
                    "RAh": 4.949888889,
                    "DEd": 33.16611111
                },
                {
                    "id": 10,
                    "bfID": "112Bet Tau",
                    "RAh": 5.438194444,
                    "DEd": 28.6075
                },
                {
                    "id": 11,
                    "bfID": "37The Aur",
                    "RAh": 5.995361111,
                    "DEd": 37.2125
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ]
            ]
        },
        {
            "Name": "Columba",
            "RAh": "6.368555556",
            "DEd": "-33.43638889",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Del Col",
                    "RAh": 6.368555556,
                    "DEd": -33.43638889
                },
                {
                    "id": 1,
                    "bfID": "Kap Col",
                    "RAh": 6.275861111,
                    "DEd": -35.14055556
                },
                {
                    "id": 2,
                    "bfID": "Kap Col",
                    "RAh": 6.275861111,
                    "DEd": -35.14055556
                },
                {
                    "id": 3,
                    "bfID": "Gam Col",
                    "RAh": 5.958944444,
                    "DEd": -35.28333333
                },
                {
                    "id": 4,
                    "bfID": "Gam Col",
                    "RAh": 5.958944444,
                    "DEd": -35.28333333
                },
                {
                    "id": 5,
                    "bfID": "Bet Col",
                    "RAh": 5.849333333,
                    "DEd": -35.76833333
                },
                {
                    "id": 6,
                    "bfID": "Bet Col",
                    "RAh": 5.849333333,
                    "DEd": -35.76833333
                },
                {
                    "id": 7,
                    "bfID": "Eta Col",
                    "RAh": 5.985777778,
                    "DEd": -42.81527778
                },
                {
                    "id": 8,
                    "bfID": "Bet Col",
                    "RAh": 5.849333333,
                    "DEd": -35.76833333
                },
                {
                    "id": 9,
                    "bfID": "Alp Col",
                    "RAh": 5.660805556,
                    "DEd": -34.07416667
                },
                {
                    "id": 10,
                    "bfID": "Alp Col",
                    "RAh": 5.660805556,
                    "DEd": -34.07416667
                },
                {
                    "id": 11,
                    "bfID": "Eps Col",
                    "RAh": 5.520194444,
                    "DEd": -35.47055556
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ]
            ]
        },
        {
            "Name": "Circinus",
            "RAh": "14.70844444",
            "DEd": "-64.97527778",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Cir",
                    "RAh": 14.70844444,
                    "DEd": -64.97527778
                },
                {
                    "id": 1,
                    "bfID": "Gam Cir",
                    "RAh": 15.38963889,
                    "DEd": -59.32083333
                },
                {
                    "id": 2,
                    "bfID": "Alp Cir",
                    "RAh": 14.70844444,
                    "DEd": -64.97527778
                },
                {
                    "id": 3,
                    "bfID": "Bet Cir",
                    "RAh": 15.29188889,
                    "DEd": -58.80111111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ]
            ]
        },
        {
            "Name": "Corona Australis",
            "RAh": "18.72969444",
            "DEd": "-38.32361111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Lam CrA",
                    "RAh": 18.72969444,
                    "DEd": -38.32361111
                },
                {
                    "id": 1,
                    "bfID": "Lam CrA",
                    "RAh": 18.72969444,
                    "DEd": -38.32361111
                },
                {
                    "id": 2,
                    "bfID": "Lam CrA",
                    "RAh": 18.72969444,
                    "DEd": -38.32361111
                },
                {
                    "id": 3,
                    "bfID": "Eps CrA",
                    "RAh": 18.97872222,
                    "DEd": -37.1075
                },
                {
                    "id": 4,
                    "bfID": "Eps CrA",
                    "RAh": 18.97872222,
                    "DEd": -37.1075
                },
                {
                    "id": 5,
                    "bfID": "Gam CrA",
                    "RAh": 19.10697222,
                    "DEd": -37.06333333
                },
                {
                    "id": 6,
                    "bfID": "Gam CrA",
                    "RAh": 19.10697222,
                    "DEd": -37.06333333
                },
                {
                    "id": 7,
                    "bfID": "Alp CrA",
                    "RAh": 19.15786111,
                    "DEd": -37.90444444
                },
                {
                    "id": 8,
                    "bfID": "Alp CrA",
                    "RAh": 19.15786111,
                    "DEd": -37.90444444
                },
                {
                    "id": 9,
                    "bfID": "Bet CrA",
                    "RAh": 19.16713889,
                    "DEd": -39.34083333
                },
                {
                    "id": 10,
                    "bfID": "Bet CrA",
                    "RAh": 19.16713889,
                    "DEd": -39.34083333
                },
                {
                    "id": 11,
                    "bfID": "Del CrA",
                    "RAh": 19.13913889,
                    "DEd": -40.49666667
                },
                {
                    "id": 12,
                    "bfID": "Del CrA",
                    "RAh": 19.13913889,
                    "DEd": -40.49666667
                },
                {
                    "id": 13,
                    "bfID": "Zet CrA",
                    "RAh": 19.05191667,
                    "DEd": -42.09527778
                },
                {
                    "id": 14,
                    "bfID": "Zet CrA",
                    "RAh": 19.05191667,
                    "DEd": -42.09527778
                },
                {
                    "id": 15,
                    "bfID": "Zet CrA",
                    "RAh": 19.05191667,
                    "DEd": -42.09527778
                },
                {
                    "id": 16,
                    "bfID": "Lam CrA",
                    "RAh": 18.72969444,
                    "DEd": -38.32361111
                },
                {
                    "id": 17,
                    "bfID": "Lam CrA",
                    "RAh": 18.72969444,
                    "DEd": -38.32361111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ]
            ]
        },
        {
            "Name": "Corona Borealis",
            "RAh": "15.54883333",
            "DEd": "31.35916667",
            "stars": [
                {
                    "id": 0,
                    "bfID": "4The CrB",
                    "RAh": 15.54883333,
                    "DEd": 31.35916667
                },
                {
                    "id": 1,
                    "bfID": "3Bet CrB",
                    "RAh": 15.46380556,
                    "DEd": 29.10583333
                },
                {
                    "id": 2,
                    "bfID": "3Bet CrB",
                    "RAh": 15.46380556,
                    "DEd": 29.10583333
                },
                {
                    "id": 3,
                    "bfID": "5Alp CrB",
                    "RAh": 15.57813889,
                    "DEd": 26.71472222
                },
                {
                    "id": 4,
                    "bfID": "5Alp CrB",
                    "RAh": 15.57813889,
                    "DEd": 26.71472222
                },
                {
                    "id": 5,
                    "bfID": "8Gam CrB",
                    "RAh": 15.71238889,
                    "DEd": 26.29555556
                },
                {
                    "id": 6,
                    "bfID": "8Gam CrB",
                    "RAh": 15.71238889,
                    "DEd": 26.29555556
                },
                {
                    "id": 7,
                    "bfID": "10Del CrB",
                    "RAh": 15.82658333,
                    "DEd": 26.06833333
                },
                {
                    "id": 8,
                    "bfID": "10Del CrB",
                    "RAh": 15.82658333,
                    "DEd": 26.06833333
                },
                {
                    "id": 9,
                    "bfID": "13Eps CrB",
                    "RAh": 15.95980556,
                    "DEd": 26.87777778
                },
                {
                    "id": 10,
                    "bfID": "13Eps CrB",
                    "RAh": 15.95980556,
                    "DEd": 26.87777778
                },
                {
                    "id": 11,
                    "bfID": "14Iot CrB",
                    "RAh": 16.02405556,
                    "DEd": 29.85111111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ]
            ]
        },
        {
            "Name": "Corvus",
            "RAh": "12.5345",
            "DEd": "-16.19611111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "8Eta Crv",
                    "RAh": 12.5345,
                    "DEd": -16.19611111
                },
                {
                    "id": 1,
                    "bfID": "7Del Crv",
                    "RAh": 12.49775,
                    "DEd": -16.51555556
                },
                {
                    "id": 2,
                    "bfID": "7Del Crv",
                    "RAh": 12.49775,
                    "DEd": -16.51555556
                },
                {
                    "id": 3,
                    "bfID": "4Gam Crv",
                    "RAh": 12.26344444,
                    "DEd": -17.54194444
                },
                {
                    "id": 4,
                    "bfID": "4Gam Crv",
                    "RAh": 12.26344444,
                    "DEd": -17.54194444
                },
                {
                    "id": 5,
                    "bfID": "2Eps Crv",
                    "RAh": 12.16875,
                    "DEd": -22.61972222
                },
                {
                    "id": 6,
                    "bfID": "2Eps Crv",
                    "RAh": 12.16875,
                    "DEd": -22.61972222
                },
                {
                    "id": 7,
                    "bfID": "1Alp Crv",
                    "RAh": 12.14022222,
                    "DEd": -24.72888889
                },
                {
                    "id": 8,
                    "bfID": "2Eps Crv",
                    "RAh": 12.16875,
                    "DEd": -22.61972222
                },
                {
                    "id": 9,
                    "bfID": "9Bet Crv",
                    "RAh": 12.57311111,
                    "DEd": -23.39666667
                },
                {
                    "id": 10,
                    "bfID": "9Bet Crv",
                    "RAh": 12.57311111,
                    "DEd": -23.39666667
                },
                {
                    "id": 11,
                    "bfID": "7Del Crv",
                    "RAh": 12.49775,
                    "DEd": -16.51555556
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ]
            ]
        },
        {
            "Name": "Crux",
            "RAh": "12.51941667",
            "DEd": "-57.11333333",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Gam Cru",
                    "RAh": 12.51941667,
                    "DEd": -57.11333333
                },
                {
                    "id": 1,
                    "bfID": "Alp1Cru",
                    "RAh": 12.44330556,
                    "DEd": -63.09916667
                },
                {
                    "id": 2,
                    "bfID": "Bet Cru",
                    "RAh": 12.79533333,
                    "DEd": -59.68861111
                },
                {
                    "id": 3,
                    "bfID": "Del Cru",
                    "RAh": 12.25241667,
                    "DEd": -58.74888889
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ]
            ]
        },
        {
            "Name": "Delphinus",
            "RAh": "20.55355556",
            "DEd": "11.30333333",
            "stars": [
                {
                    "id": 0,
                    "bfID": "2Eps Del",
                    "RAh": 20.55355556,
                    "DEd": 11.30333333
                },
                {
                    "id": 1,
                    "bfID": "6Bet Del",
                    "RAh": 20.62583333,
                    "DEd": 14.59527778
                },
                {
                    "id": 2,
                    "bfID": "6Bet Del",
                    "RAh": 20.62583333,
                    "DEd": 14.59527778
                },
                {
                    "id": 3,
                    "bfID": "6Bet Del",
                    "RAh": 20.62583333,
                    "DEd": 14.59527778
                },
                {
                    "id": 4,
                    "bfID": "6Bet Del",
                    "RAh": 20.62583333,
                    "DEd": 14.59527778
                },
                {
                    "id": 5,
                    "bfID": "12Gam2Del",
                    "RAh": 20.77763889,
                    "DEd": 16.12416667
                },
                {
                    "id": 6,
                    "bfID": "12Gam2Del",
                    "RAh": 20.77763889,
                    "DEd": 16.12416667
                },
                {
                    "id": 7,
                    "bfID": "11Del Del",
                    "RAh": 20.72430556,
                    "DEd": 15.07444444
                },
                {
                    "id": 8,
                    "bfID": "11Del Del",
                    "RAh": 20.72430556,
                    "DEd": 15.07444444
                },
                {
                    "id": 9,
                    "bfID": "6Bet Del",
                    "RAh": 20.62583333,
                    "DEd": 14.59527778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ]
            ]
        },
        {
            "Name": "Draco",
            "RAh": "17.89213889",
            "DEd": "56.87277778",
            "stars": [
                {
                    "id": 0,
                    "bfID": "32Xi Dra",
                    "RAh": 17.89213889,
                    "DEd": 56.87277778
                },
                {
                    "id": 1,
                    "bfID": "33Gam Dra",
                    "RAh": 17.94344444,
                    "DEd": 51.48888889
                },
                {
                    "id": 2,
                    "bfID": "33Gam Dra",
                    "RAh": 17.94344444,
                    "DEd": 51.48888889
                },
                {
                    "id": 3,
                    "bfID": "23Bet Dra",
                    "RAh": 17.50722222,
                    "DEd": 52.30138889
                },
                {
                    "id": 4,
                    "bfID": "23Bet Dra",
                    "RAh": 17.50722222,
                    "DEd": 52.30138889
                },
                {
                    "id": 5,
                    "bfID": "25Nu 2Dra",
                    "RAh": 17.53777778,
                    "DEd": 55.17305556
                },
                {
                    "id": 6,
                    "bfID": "25Nu 2Dra",
                    "RAh": 17.53777778,
                    "DEd": 55.17305556
                },
                {
                    "id": 7,
                    "bfID": "32Xi Dra",
                    "RAh": 17.89213889,
                    "DEd": 56.87277778
                },
                {
                    "id": 8,
                    "bfID": "32Xi Dra",
                    "RAh": 17.89213889,
                    "DEd": 56.87277778
                },
                {
                    "id": 9,
                    "bfID": "57Del Dra",
                    "RAh": 19.20925,
                    "DEd": 67.66166667
                },
                {
                    "id": 10,
                    "bfID": "57Del Dra",
                    "RAh": 19.20925,
                    "DEd": 67.66166667
                },
                {
                    "id": 11,
                    "bfID": "63Eps Dra",
                    "RAh": 19.80288889,
                    "DEd": 70.26777778
                },
                {
                    "id": 12,
                    "bfID": "63Eps Dra",
                    "RAh": 19.80288889,
                    "DEd": 70.26777778
                },
                {
                    "id": 13,
                    "bfID": "44Chi Dra",
                    "RAh": 18.35094444,
                    "DEd": 72.73277778
                },
                {
                    "id": 14,
                    "bfID": "44Chi Dra",
                    "RAh": 18.35094444,
                    "DEd": 72.73277778
                },
                {
                    "id": 15,
                    "bfID": "22Zet Dra",
                    "RAh": 17.14644444,
                    "DEd": 65.71472222
                },
                {
                    "id": 16,
                    "bfID": "22Zet Dra",
                    "RAh": 17.14644444,
                    "DEd": 65.71472222
                },
                {
                    "id": 17,
                    "bfID": "14Eta Dra",
                    "RAh": 16.39986111,
                    "DEd": 61.51416667
                },
                {
                    "id": 18,
                    "bfID": "14Eta Dra",
                    "RAh": 16.39986111,
                    "DEd": 61.51416667
                },
                {
                    "id": 19,
                    "bfID": "13The Dra",
                    "RAh": 16.03147222,
                    "DEd": 58.56527778
                },
                {
                    "id": 20,
                    "bfID": "13The Dra",
                    "RAh": 16.03147222,
                    "DEd": 58.56527778
                },
                {
                    "id": 21,
                    "bfID": "12Iot Dra",
                    "RAh": 15.4155,
                    "DEd": 58.96611111
                },
                {
                    "id": 22,
                    "bfID": "12Iot Dra",
                    "RAh": 15.4155,
                    "DEd": 58.96611111
                },
                {
                    "id": 23,
                    "bfID": "11Alp Dra",
                    "RAh": 14.07313889,
                    "DEd": 64.37583333
                },
                {
                    "id": 24,
                    "bfID": "11Alp Dra",
                    "RAh": 14.07313889,
                    "DEd": 64.37583333
                },
                {
                    "id": 25,
                    "bfID": "5Kap Dra",
                    "RAh": 12.55805556,
                    "DEd": 69.78833333
                },
                {
                    "id": 26,
                    "bfID": "5Kap Dra",
                    "RAh": 12.55805556,
                    "DEd": 69.78833333
                },
                {
                    "id": 27,
                    "bfID": "1Lam Dra",
                    "RAh": 11.52338889,
                    "DEd": 69.33111111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ]
            ]
        },
        {
            "Name": "Norma",
            "RAh": "16.22463889",
            "DEd": "-54.63055556",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Kap Nor",
                    "RAh": 16.22463889,
                    "DEd": -54.63055556
                },
                {
                    "id": 1,
                    "bfID": "Gam2Nor",
                    "RAh": 16.33066667,
                    "DEd": -50.15555556
                },
                {
                    "id": 2,
                    "bfID": "Gam2Nor",
                    "RAh": 16.33066667,
                    "DEd": -50.15555556
                },
                {
                    "id": 3,
                    "bfID": "Eps Nor",
                    "RAh": 16.45308333,
                    "DEd": -47.555
                },
                {
                    "id": 4,
                    "bfID": "Eps Nor",
                    "RAh": 16.45308333,
                    "DEd": -47.555
                },
                {
                    "id": 5,
                    "bfID": "Eta Nor",
                    "RAh": 16.05358333,
                    "DEd": -49.22972222
                },
                {
                    "id": 6,
                    "bfID": "Eta Nor",
                    "RAh": 16.05358333,
                    "DEd": -49.22972222
                },
                {
                    "id": 7,
                    "bfID": "Gam2Nor",
                    "RAh": 16.33066667,
                    "DEd": -50.15555556
                },
                {
                    "id": 8,
                    "bfID": "Eta Nor",
                    "RAh": 16.05358333,
                    "DEd": -49.22972222
                },
                {
                    "id": 9,
                    "bfID": "Kap Nor",
                    "RAh": 16.22463889,
                    "DEd": -54.63055556
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ]
            ]
        },
        {
            "Name": "Sagitta",
            "RAh": "19.68413889",
            "DEd": "17.47611111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "6Bet Sge",
                    "RAh": 19.68413889,
                    "DEd": 17.47611111
                },
                {
                    "id": 1,
                    "bfID": "7Del Sge",
                    "RAh": 19.78980556,
                    "DEd": 18.53416667
                },
                {
                    "id": 2,
                    "bfID": "7Del Sge",
                    "RAh": 19.78980556,
                    "DEd": 18.53416667
                },
                {
                    "id": 3,
                    "bfID": "5Alp Sge",
                    "RAh": 19.66827778,
                    "DEd": 18.01388889
                },
                {
                    "id": 4,
                    "bfID": "7Del Sge",
                    "RAh": 19.78980556,
                    "DEd": 18.53416667
                },
                {
                    "id": 5,
                    "bfID": "12Gam Sge",
                    "RAh": 19.97927778,
                    "DEd": 19.49222222
                },
                {
                    "id": 6,
                    "bfID": "12Gam Sge",
                    "RAh": 19.97927778,
                    "DEd": 19.49222222
                },
                {
                    "id": 7,
                    "bfID": "16Eta Sge",
                    "RAh": 20.08597222,
                    "DEd": 19.99111111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Fornax",
            "RAh": "2.818166667",
            "DEd": "-32.40583333",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Bet For",
                    "RAh": 2.818166667,
                    "DEd": -32.40583333
                },
                {
                    "id": 1,
                    "bfID": "Alp For",
                    "RAh": 3.201194444,
                    "DEd": -28.98694444
                }
            ],
            "lines": [
                [
                    0,
                    1
                ]
            ]
        },
        {
            "Name": "Canis Major",
            "RAh": "6.903166667",
            "DEd": "-12.03861111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "14The CMa",
                    "RAh": 6.903166667,
                    "DEd": -12.03861111
                },
                {
                    "id": 1,
                    "bfID": "23Gam CMa",
                    "RAh": 7.062638889,
                    "DEd": -15.63333333
                },
                {
                    "id": 2,
                    "bfID": "23Gam CMa",
                    "RAh": 7.062638889,
                    "DEd": -15.63333333
                },
                {
                    "id": 3,
                    "bfID": "20Iot CMa",
                    "RAh": 6.935611111,
                    "DEd": -17.05416667
                },
                {
                    "id": 4,
                    "bfID": "20Iot CMa",
                    "RAh": 6.935611111,
                    "DEd": -17.05416667
                },
                {
                    "id": 5,
                    "bfID": "9Alp CMa",
                    "RAh": 6.752472222,
                    "DEd": -16.71611111
                },
                {
                    "id": 6,
                    "bfID": "9Alp CMa",
                    "RAh": 6.752472222,
                    "DEd": -16.71611111
                },
                {
                    "id": 7,
                    "bfID": "24Omi2CMa",
                    "RAh": 7.050416667,
                    "DEd": -23.83333333
                },
                {
                    "id": 8,
                    "bfID": "24Omi2CMa",
                    "RAh": 7.050416667,
                    "DEd": -23.83333333
                },
                {
                    "id": 9,
                    "bfID": "25Del CMa",
                    "RAh": 7.139861111,
                    "DEd": -26.39333333
                },
                {
                    "id": 10,
                    "bfID": "25Del CMa",
                    "RAh": 7.139861111,
                    "DEd": -26.39333333
                },
                {
                    "id": 11,
                    "bfID": "28Ome CMa",
                    "RAh": 7.246861111,
                    "DEd": -26.77277778
                },
                {
                    "id": 12,
                    "bfID": "28Ome CMa",
                    "RAh": 7.246861111,
                    "DEd": -26.77277778
                },
                {
                    "id": 13,
                    "bfID": "31Eta CMa",
                    "RAh": 7.401583333,
                    "DEd": -29.30305556
                },
                {
                    "id": 14,
                    "bfID": "21Eps CMa",
                    "RAh": 6.977083333,
                    "DEd": -28.97222222
                },
                {
                    "id": 15,
                    "bfID": "22Sig CMa",
                    "RAh": 7.028638889,
                    "DEd": -27.93472222
                },
                {
                    "id": 16,
                    "bfID": "22Sig CMa",
                    "RAh": 7.028638889,
                    "DEd": -27.93472222
                },
                {
                    "id": 17,
                    "bfID": "25Del CMa",
                    "RAh": 7.139861111,
                    "DEd": -26.39333333
                },
                {
                    "id": 18,
                    "bfID": "22Sig CMa",
                    "RAh": 7.028638889,
                    "DEd": -27.93472222
                },
                {
                    "id": 19,
                    "bfID": "22Sig CMa",
                    "RAh": 7.028638889,
                    "DEd": -27.93472222
                },
                {
                    "id": 20,
                    "bfID": "22Sig CMa",
                    "RAh": 7.028638889,
                    "DEd": -27.93472222
                },
                {
                    "id": 21,
                    "bfID": "7Nu 2CMa",
                    "RAh": 6.611388889,
                    "DEd": -19.25583333
                },
                {
                    "id": 22,
                    "bfID": "7Nu 2CMa",
                    "RAh": 6.611388889,
                    "DEd": -19.25583333
                },
                {
                    "id": 23,
                    "bfID": "5Xi 2CMa",
                    "RAh": 6.584277778,
                    "DEd": -22.96472222
                },
                {
                    "id": 24,
                    "bfID": "7Nu 2CMa",
                    "RAh": 6.611388889,
                    "DEd": -19.25583333
                },
                {
                    "id": 25,
                    "bfID": "2Bet CMa",
                    "RAh": 6.378333333,
                    "DEd": -17.95583333
                },
                {
                    "id": 26,
                    "bfID": "7Nu 2CMa",
                    "RAh": 6.611388889,
                    "DEd": -19.25583333
                },
                {
                    "id": 27,
                    "bfID": "9Alp CMa",
                    "RAh": 6.752472222,
                    "DEd": -16.71611111
                },
                {
                    "id": 28,
                    "bfID": "21Eps CMa",
                    "RAh": 6.977083333,
                    "DEd": -28.97222222
                },
                {
                    "id": 29,
                    "bfID": "13Kap CMa",
                    "RAh": 6.830694444,
                    "DEd": -32.50861111
                },
                {
                    "id": 30,
                    "bfID": "1Zet CMa",
                    "RAh": 6.338555556,
                    "DEd": -30.06333333
                },
                {
                    "id": 31,
                    "bfID": "21Eps CMa",
                    "RAh": 6.977083333,
                    "DEd": -28.97222222
                },
                {
                    "id": 32,
                    "bfID": "20Iot CMa",
                    "RAh": 6.935611111,
                    "DEd": -17.05416667
                },
                {
                    "id": 33,
                    "bfID": "14The CMa",
                    "RAh": 6.903166667,
                    "DEd": -12.03861111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ],
                [
                    28,
                    29
                ],
                [
                    30,
                    31
                ],
                [
                    32,
                    33
                ]
            ]
        },
        {
            "Name": "Grus",
            "RAh": "23.11466667",
            "DEd": "-43.52055556",
            "stars": [
                {
                    "id": 0,
                    "bfID": "The Gru",
                    "RAh": 23.11466667,
                    "DEd": -43.52055556
                },
                {
                    "id": 1,
                    "bfID": "Del1Gru",
                    "RAh": 22.48783333,
                    "DEd": -43.49555556
                },
                {
                    "id": 2,
                    "bfID": "Del1Gru",
                    "RAh": 22.48783333,
                    "DEd": -43.49555556
                },
                {
                    "id": 3,
                    "bfID": "Alp Gru",
                    "RAh": 22.13722222,
                    "DEd": -46.96111111
                },
                {
                    "id": 4,
                    "bfID": "Alp Gru",
                    "RAh": 22.13722222,
                    "DEd": -46.96111111
                },
                {
                    "id": 5,
                    "bfID": "Bet Gru",
                    "RAh": 22.71113889,
                    "DEd": -46.88472222
                },
                {
                    "id": 6,
                    "bfID": "Bet Gru",
                    "RAh": 22.71113889,
                    "DEd": -46.88472222
                },
                {
                    "id": 7,
                    "bfID": "Iot Gru",
                    "RAh": 23.17266667,
                    "DEd": -45.24666667
                },
                {
                    "id": 8,
                    "bfID": "Iot Gru",
                    "RAh": 23.17266667,
                    "DEd": -45.24666667
                },
                {
                    "id": 9,
                    "bfID": "The Gru",
                    "RAh": 23.11466667,
                    "DEd": -43.52055556
                },
                {
                    "id": 10,
                    "bfID": "Bet Gru",
                    "RAh": 22.71113889,
                    "DEd": -46.88472222
                },
                {
                    "id": 11,
                    "bfID": "Zet Gru",
                    "RAh": 23.01466667,
                    "DEd": -52.75416667
                },
                {
                    "id": 12,
                    "bfID": "Bet Gru",
                    "RAh": 22.71113889,
                    "DEd": -46.88472222
                },
                {
                    "id": 13,
                    "bfID": "Eps Gru",
                    "RAh": 22.80925,
                    "DEd": -51.31694444
                },
                {
                    "id": 14,
                    "bfID": "Alp Gru",
                    "RAh": 22.13722222,
                    "DEd": -46.96111111
                },
                {
                    "id": 15,
                    "bfID": "Lam Gru",
                    "RAh": 22.10191667,
                    "DEd": -39.54333333
                },
                {
                    "id": 16,
                    "bfID": "Lam Gru",
                    "RAh": 22.10191667,
                    "DEd": -39.54333333
                },
                {
                    "id": 17,
                    "bfID": "Gam Gru",
                    "RAh": 21.89880556,
                    "DEd": -37.365
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ]
            ]
        },
        {
            "Name": "Horologium",
            "RAh": "4.233361111",
            "DEd": "-42.29444444",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Hor",
                    "RAh": 4.233361111,
                    "DEd": -42.29444444
                },
                {
                    "id": 1,
                    "bfID": "Zet Hor",
                    "RAh": 2.677666667,
                    "DEd": -54.55
                },
                {
                    "id": 2,
                    "bfID": "Zet Hor",
                    "RAh": 2.677666667,
                    "DEd": -54.55
                },
                {
                    "id": 3,
                    "bfID": "Mu Hor",
                    "RAh": 3.060222222,
                    "DEd": -59.73777778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ]
            ]
        },
        {
            "Name": "Hydra",
            "RAh": "8.720416667",
            "DEd": "3.398611111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "7Eta Hya",
                    "RAh": 8.720416667,
                    "DEd": 3.398611111
                },
                {
                    "id": 1,
                    "bfID": "5Sig Hya",
                    "RAh": 8.645944444,
                    "DEd": 3.341388889
                },
                {
                    "id": 2,
                    "bfID": "5Sig Hya",
                    "RAh": 8.645944444,
                    "DEd": 3.341388889
                },
                {
                    "id": 3,
                    "bfID": "4Del Hya",
                    "RAh": 8.627611111,
                    "DEd": 5.703611111
                },
                {
                    "id": 4,
                    "bfID": "4Del Hya",
                    "RAh": 8.627611111,
                    "DEd": 5.703611111
                },
                {
                    "id": 5,
                    "bfID": "11Eps Hya",
                    "RAh": 8.779611111,
                    "DEd": 6.418888889
                },
                {
                    "id": 6,
                    "bfID": "11Eps Hya",
                    "RAh": 8.779611111,
                    "DEd": 6.418888889
                },
                {
                    "id": 7,
                    "bfID": "13Rho Hya",
                    "RAh": 8.807222222,
                    "DEd": 5.837777778
                },
                {
                    "id": 8,
                    "bfID": "13Rho Hya",
                    "RAh": 8.807222222,
                    "DEd": 5.837777778
                },
                {
                    "id": 9,
                    "bfID": "7Eta Hya",
                    "RAh": 8.720416667,
                    "DEd": 3.398611111
                },
                {
                    "id": 10,
                    "bfID": "13Rho Hya",
                    "RAh": 8.807222222,
                    "DEd": 5.837777778
                },
                {
                    "id": 11,
                    "bfID": "16Zet Hya",
                    "RAh": 8.923222222,
                    "DEd": 5.945555556
                },
                {
                    "id": 12,
                    "bfID": "16Zet Hya",
                    "RAh": 8.923222222,
                    "DEd": 5.945555556
                },
                {
                    "id": 13,
                    "bfID": "22The Hya",
                    "RAh": 9.239416667,
                    "DEd": 2.314166667
                },
                {
                    "id": 14,
                    "bfID": "22The Hya",
                    "RAh": 9.239416667,
                    "DEd": 2.314166667
                },
                {
                    "id": 15,
                    "bfID": "32Tau2Hya",
                    "RAh": 9.533027778,
                    "DEd": -1.185
                },
                {
                    "id": 16,
                    "bfID": "32Tau2Hya",
                    "RAh": 9.533027778,
                    "DEd": -1.185
                },
                {
                    "id": 17,
                    "bfID": "31Tau1Hya",
                    "RAh": 9.485805556,
                    "DEd": -2.768888889
                },
                {
                    "id": 18,
                    "bfID": "31Tau1Hya",
                    "RAh": 9.485805556,
                    "DEd": -2.768888889
                },
                {
                    "id": 19,
                    "bfID": "30Alp Hya",
                    "RAh": 9.459777778,
                    "DEd": -8.658611111
                },
                {
                    "id": 20,
                    "bfID": "30Alp Hya",
                    "RAh": 9.459777778,
                    "DEd": -8.658611111
                },
                {
                    "id": 21,
                    "bfID": "39Ups1Hya",
                    "RAh": 9.857972222,
                    "DEd": -14.84666667
                },
                {
                    "id": 22,
                    "bfID": "39Ups1Hya",
                    "RAh": 9.857972222,
                    "DEd": -14.84666667
                },
                {
                    "id": 23,
                    "bfID": "41Lam Hya",
                    "RAh": 10.17647222,
                    "DEd": -12.35416667
                },
                {
                    "id": 24,
                    "bfID": "41Lam Hya",
                    "RAh": 10.17647222,
                    "DEd": -12.35416667
                },
                {
                    "id": 25,
                    "bfID": "42Mu Hya",
                    "RAh": 10.43483333,
                    "DEd": -16.83638889
                },
                {
                    "id": 26,
                    "bfID": "42Mu Hya",
                    "RAh": 10.43483333,
                    "DEd": -16.83638889
                },
                {
                    "id": 27,
                    "bfID": "Nu Hya",
                    "RAh": 10.82708333,
                    "DEd": -16.19361111
                },
                {
                    "id": 28,
                    "bfID": "Nu Hya",
                    "RAh": 10.82708333,
                    "DEd": -16.19361111
                },
                {
                    "id": 29,
                    "bfID": "Xi Hya",
                    "RAh": 11.55002778,
                    "DEd": -31.85777778
                },
                {
                    "id": 30,
                    "bfID": "Xi Hya",
                    "RAh": 11.55002778,
                    "DEd": -31.85777778
                },
                {
                    "id": 31,
                    "bfID": "Bet Hya",
                    "RAh": 11.88183333,
                    "DEd": -33.90805556
                },
                {
                    "id": 32,
                    "bfID": "Bet Hya",
                    "RAh": 11.88183333,
                    "DEd": -33.90805556
                },
                {
                    "id": 33,
                    "bfID": "45Psi Hya",
                    "RAh": 13.15091667,
                    "DEd": -23.11805556
                },
                {
                    "id": 34,
                    "bfID": "45Psi Hya",
                    "RAh": 13.15091667,
                    "DEd": -23.11805556
                },
                {
                    "id": 35,
                    "bfID": "46Gam Hya",
                    "RAh": 13.31536111,
                    "DEd": -23.17166667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ],
                [
                    28,
                    29
                ],
                [
                    30,
                    31
                ],
                [
                    32,
                    33
                ],
                [
                    34,
                    35
                ]
            ]
        },
        {
            "Name": "Hydrus",
            "RAh": "0.429194444",
            "DEd": "-77.25416667",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Bet Hyi",
                    "RAh": 0.429194444,
                    "DEd": -77.25416667
                },
                {
                    "id": 1,
                    "bfID": "Gam Hyi",
                    "RAh": 3.787305556,
                    "DEd": -74.23888889
                },
                {
                    "id": 2,
                    "bfID": "Gam Hyi",
                    "RAh": 3.787305556,
                    "DEd": -74.23888889
                },
                {
                    "id": 3,
                    "bfID": "Eps Hyi",
                    "RAh": 2.659833333,
                    "DEd": -68.26694444
                },
                {
                    "id": 4,
                    "bfID": "Eps Hyi",
                    "RAh": 2.659833333,
                    "DEd": -68.26694444
                },
                {
                    "id": 5,
                    "bfID": "Del Hyi",
                    "RAh": 2.362472222,
                    "DEd": -68.65944444
                },
                {
                    "id": 6,
                    "bfID": "Del Hyi",
                    "RAh": 2.362472222,
                    "DEd": -68.65944444
                },
                {
                    "id": 7,
                    "bfID": "Alp Hyi",
                    "RAh": 1.9795,
                    "DEd": -61.56972222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Indus",
            "RAh": "21.33111111",
            "DEd": "-53.44972222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "The Ind",
                    "RAh": 21.33111111,
                    "DEd": -53.44972222
                },
                {
                    "id": 1,
                    "bfID": "Alp Ind",
                    "RAh": 20.62611111,
                    "DEd": -47.29138889
                },
                {
                    "id": 2,
                    "bfID": "Alp Ind",
                    "RAh": 20.62611111,
                    "DEd": -47.29138889
                },
                {
                    "id": 3,
                    "bfID": "Bet Ind",
                    "RAh": 20.9135,
                    "DEd": -58.45416667
                },
                {
                    "id": 4,
                    "bfID": "Bet Ind",
                    "RAh": 20.9135,
                    "DEd": -58.45416667
                },
                {
                    "id": 5,
                    "bfID": "The Ind",
                    "RAh": 21.33111111,
                    "DEd": -53.44972222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ]
            ]
        },
        {
            "Name": "Lacerta",
            "RAh": "22.26616667",
            "DEd": "37.74888889",
            "stars": [
                {
                    "id": 0,
                    "bfID": "1 Lac",
                    "RAh": 22.26616667,
                    "DEd": 37.74888889
                },
                {
                    "id": 1,
                    "bfID": "6 Lac",
                    "RAh": 22.50813889,
                    "DEd": 43.12333333
                },
                {
                    "id": 2,
                    "bfID": "6 Lac",
                    "RAh": 22.50813889,
                    "DEd": 43.12333333
                },
                {
                    "id": 3,
                    "bfID": "5 Lac",
                    "RAh": 22.49216667,
                    "DEd": 47.70694444
                },
                {
                    "id": 4,
                    "bfID": "5 Lac",
                    "RAh": 22.49216667,
                    "DEd": 47.70694444
                },
                {
                    "id": 5,
                    "bfID": "4 Lac",
                    "RAh": 22.40861111,
                    "DEd": 49.47638889
                },
                {
                    "id": 6,
                    "bfID": "4 Lac",
                    "RAh": 22.40861111,
                    "DEd": 49.47638889
                },
                {
                    "id": 7,
                    "bfID": "3Bet Lac",
                    "RAh": 22.39266667,
                    "DEd": 52.22916667
                },
                {
                    "id": 8,
                    "bfID": "3Bet Lac",
                    "RAh": 22.39266667,
                    "DEd": 52.22916667
                },
                {
                    "id": 9,
                    "bfID": "7Alp Lac",
                    "RAh": 22.52152778,
                    "DEd": 50.2825
                },
                {
                    "id": 10,
                    "bfID": "7Alp Lac",
                    "RAh": 22.52152778,
                    "DEd": 50.2825
                },
                {
                    "id": 11,
                    "bfID": "5 Lac",
                    "RAh": 22.49216667,
                    "DEd": 47.70694444
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ]
            ]
        },
        {
            "Name": "Monoceros",
            "RAh": "6.247583333",
            "DEd": "-6.274722222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "5Gam Mon",
                    "RAh": 6.247583333,
                    "DEd": -6.274722222
                },
                {
                    "id": 1,
                    "bfID": "11Bet Mon",
                    "RAh": 6.480277778,
                    "DEd": -7.032777778
                },
                {
                    "id": 2,
                    "bfID": "11Bet Mon",
                    "RAh": 6.480277778,
                    "DEd": -7.032777778
                },
                {
                    "id": 3,
                    "bfID": "22Del Mon",
                    "RAh": 7.19775,
                    "DEd": -0.492777778
                },
                {
                    "id": 4,
                    "bfID": "22Del Mon",
                    "RAh": 7.19775,
                    "DEd": -0.492777778
                },
                {
                    "id": 5,
                    "bfID": "8Eps Mon",
                    "RAh": 6.396138889,
                    "DEd": 4.592777778
                },
                {
                    "id": 6,
                    "bfID": "8Eps Mon",
                    "RAh": 6.396138889,
                    "DEd": 4.592777778
                },
                {
                    "id": 7,
                    "bfID": "8Eps Mon",
                    "RAh": 6.396138889,
                    "DEd": 4.592777778
                },
                {
                    "id": 8,
                    "bfID": "22Del Mon",
                    "RAh": 7.19775,
                    "DEd": -0.492777778
                },
                {
                    "id": 9,
                    "bfID": "29Zet Mon",
                    "RAh": 8.143222222,
                    "DEd": -2.983888889
                },
                {
                    "id": 10,
                    "bfID": "29Zet Mon",
                    "RAh": 8.143222222,
                    "DEd": -2.983888889
                },
                {
                    "id": 11,
                    "bfID": "26Alp Mon",
                    "RAh": 7.687444444,
                    "DEd": -9.551111111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ]
            ]
        },
        {
            "Name": "Lepus",
            "RAh": "6.102583333",
            "DEd": "-14.93527778",
            "stars": [
                {
                    "id": 0,
                    "bfID": "18The Lep",
                    "RAh": 6.102583333,
                    "DEd": -14.93527778
                },
                {
                    "id": 1,
                    "bfID": "16Eta Lep",
                    "RAh": 5.940083333,
                    "DEd": -14.16777778
                },
                {
                    "id": 2,
                    "bfID": "16Eta Lep",
                    "RAh": 5.940083333,
                    "DEd": -14.16777778
                },
                {
                    "id": 3,
                    "bfID": "14Zet Lep",
                    "RAh": 5.782583333,
                    "DEd": -14.82194444
                },
                {
                    "id": 4,
                    "bfID": "14Zet Lep",
                    "RAh": 5.782583333,
                    "DEd": -14.82194444
                },
                {
                    "id": 5,
                    "bfID": "11Alp Lep",
                    "RAh": 5.5455,
                    "DEd": -17.82222222
                },
                {
                    "id": 6,
                    "bfID": "11Alp Lep",
                    "RAh": 5.5455,
                    "DEd": -17.82222222
                },
                {
                    "id": 7,
                    "bfID": "5Mu Lep",
                    "RAh": 5.215527778,
                    "DEd": -16.20555556
                },
                {
                    "id": 8,
                    "bfID": "11Alp Lep",
                    "RAh": 5.5455,
                    "DEd": -17.82222222
                },
                {
                    "id": 9,
                    "bfID": "15Del Lep",
                    "RAh": 5.855361111,
                    "DEd": -20.87916667
                },
                {
                    "id": 10,
                    "bfID": "15Del Lep",
                    "RAh": 5.855361111,
                    "DEd": -20.87916667
                },
                {
                    "id": 11,
                    "bfID": "13Gam Lep",
                    "RAh": 5.741055556,
                    "DEd": -22.44833333
                },
                {
                    "id": 12,
                    "bfID": "13Gam Lep",
                    "RAh": 5.741055556,
                    "DEd": -22.44833333
                },
                {
                    "id": 13,
                    "bfID": "9Bet Lep",
                    "RAh": 5.47075,
                    "DEd": -20.75944444
                },
                {
                    "id": 14,
                    "bfID": "9Bet Lep",
                    "RAh": 5.47075,
                    "DEd": -20.75944444
                },
                {
                    "id": 15,
                    "bfID": "2Eps Lep",
                    "RAh": 5.091027778,
                    "DEd": -22.37111111
                },
                {
                    "id": 16,
                    "bfID": "11Alp Lep",
                    "RAh": 5.5455,
                    "DEd": -17.82222222
                },
                {
                    "id": 17,
                    "bfID": "9Bet Lep",
                    "RAh": 5.47075,
                    "DEd": -20.75944444
                },
                {
                    "id": 18,
                    "bfID": "5Mu Lep",
                    "RAh": 5.215527778,
                    "DEd": -16.20555556
                },
                {
                    "id": 19,
                    "bfID": "6Lam Lep",
                    "RAh": 5.32625,
                    "DEd": -13.17666667
                },
                {
                    "id": 20,
                    "bfID": "5Mu Lep",
                    "RAh": 5.215527778,
                    "DEd": -16.20555556
                },
                {
                    "id": 21,
                    "bfID": "4Kap Lep",
                    "RAh": 5.220527778,
                    "DEd": -12.94138889
                },
                {
                    "id": 22,
                    "bfID": "2Eps Lep",
                    "RAh": 5.091027778,
                    "DEd": -22.37111111
                },
                {
                    "id": 23,
                    "bfID": "5Mu Lep",
                    "RAh": 5.215527778,
                    "DEd": -16.20555556
                },
                {
                    "id": 24,
                    "bfID": "4Kap Lep",
                    "RAh": 5.220527778,
                    "DEd": -12.94138889
                },
                {
                    "id": 25,
                    "bfID": "3Iot Lep",
                    "RAh": 5.204972222,
                    "DEd": -11.86916667
                },
                {
                    "id": 26,
                    "bfID": "6Lam Lep",
                    "RAh": 5.32625,
                    "DEd": -13.17666667
                },
                {
                    "id": 27,
                    "bfID": "7Nu Lep",
                    "RAh": 5.333083333,
                    "DEd": -12.31555556
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ]
            ]
        },
        {
            "Name": "Lupus",
            "RAh": "15.84930556",
            "DEd": "-33.62722222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "5Chi Lup",
                    "RAh": 15.84930556,
                    "DEd": -33.62722222
                },
                {
                    "id": 1,
                    "bfID": "5Chi Lup",
                    "RAh": 15.84930556,
                    "DEd": -33.62722222
                },
                {
                    "id": 2,
                    "bfID": "5Chi Lup",
                    "RAh": 15.84930556,
                    "DEd": -33.62722222
                },
                {
                    "id": 3,
                    "bfID": "Eta Lup",
                    "RAh": 16.00202778,
                    "DEd": -38.39694444
                },
                {
                    "id": 4,
                    "bfID": "Eta Lup",
                    "RAh": 16.00202778,
                    "DEd": -38.39694444
                },
                {
                    "id": 5,
                    "bfID": "5Chi Lup",
                    "RAh": 15.84930556,
                    "DEd": -33.62722222
                },
                {
                    "id": 6,
                    "bfID": "Eta Lup",
                    "RAh": 16.00202778,
                    "DEd": -38.39694444
                },
                {
                    "id": 7,
                    "bfID": "Gam Lup",
                    "RAh": 15.58569444,
                    "DEd": -41.16694444
                },
                {
                    "id": 8,
                    "bfID": "Gam Lup",
                    "RAh": 15.58569444,
                    "DEd": -41.16694444
                },
                {
                    "id": 9,
                    "bfID": "Del Lup",
                    "RAh": 15.35619444,
                    "DEd": -40.6475
                },
                {
                    "id": 10,
                    "bfID": "Del Lup",
                    "RAh": 15.35619444,
                    "DEd": -40.6475
                },
                {
                    "id": 11,
                    "bfID": "Phi1Lup",
                    "RAh": 15.36344444,
                    "DEd": -36.26138889
                },
                {
                    "id": 12,
                    "bfID": "Del Lup",
                    "RAh": 15.35619444,
                    "DEd": -40.6475
                },
                {
                    "id": 13,
                    "bfID": "Bet Lup",
                    "RAh": 14.97552778,
                    "DEd": -43.13388889
                },
                {
                    "id": 14,
                    "bfID": "Gam Lup",
                    "RAh": 15.58569444,
                    "DEd": -41.16694444
                },
                {
                    "id": 15,
                    "bfID": "Ome Lup",
                    "RAh": 15.63422222,
                    "DEd": -42.5675
                },
                {
                    "id": 16,
                    "bfID": "Ome Lup",
                    "RAh": 15.63422222,
                    "DEd": -42.5675
                },
                {
                    "id": 17,
                    "bfID": "Zet Lup",
                    "RAh": 15.20475,
                    "DEd": -52.09916667
                },
                {
                    "id": 18,
                    "bfID": "Zet Lup",
                    "RAh": 15.20475,
                    "DEd": -52.09916667
                },
                {
                    "id": 19,
                    "bfID": "Alp Lup",
                    "RAh": 14.69883333,
                    "DEd": -47.38833333
                },
                {
                    "id": 20,
                    "bfID": "Zet Lup",
                    "RAh": 15.20475,
                    "DEd": -52.09916667
                },
                {
                    "id": 21,
                    "bfID": "Rho Lup",
                    "RAh": 14.63144444,
                    "DEd": -49.42583333
                },
                {
                    "id": 22,
                    "bfID": "Alp Lup",
                    "RAh": 14.69883333,
                    "DEd": -47.38833333
                },
                {
                    "id": 23,
                    "bfID": "Tau2Lup",
                    "RAh": 14.43633333,
                    "DEd": -45.37944444
                },
                {
                    "id": 24,
                    "bfID": "Alp Lup",
                    "RAh": 14.69883333,
                    "DEd": -47.38833333
                },
                {
                    "id": 25,
                    "bfID": "Bet Lup",
                    "RAh": 14.97552778,
                    "DEd": -43.13388889
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ]
            ]
        },
        {
            "Name": "Antlia",
            "RAh": "10.45252778",
            "DEd": "-31.06777778",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Ant",
                    "RAh": 10.45252778,
                    "DEd": -31.06777778
                },
                {
                    "id": 1,
                    "bfID": "Eta Ant",
                    "RAh": 9.981194444,
                    "DEd": -35.89111111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ]
            ]
        },
        {
            "Name": "Microscopium",
            "RAh": "21.29897222",
            "DEd": "-32.1725",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Eps Mic",
                    "RAh": 21.29897222,
                    "DEd": -32.1725
                },
                {
                    "id": 1,
                    "bfID": "Gam Mic",
                    "RAh": 21.02152778,
                    "DEd": -32.25777778
                },
                {
                    "id": 2,
                    "bfID": "Gam Mic",
                    "RAh": 21.02152778,
                    "DEd": -32.25777778
                },
                {
                    "id": 3,
                    "bfID": "Alp Mic",
                    "RAh": 20.83280556,
                    "DEd": -33.77972222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ]
            ]
        },
        {
            "Name": "Musca",
            "RAh": "12.77136111",
            "DEd": "-68.10805556",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Bet Mus",
                    "RAh": 12.77136111,
                    "DEd": -68.10805556
                },
                {
                    "id": 1,
                    "bfID": "Lam Mus",
                    "RAh": 11.76011111,
                    "DEd": -66.72861111
                },
                {
                    "id": 2,
                    "bfID": "Lam Mus",
                    "RAh": 11.76011111,
                    "DEd": -66.72861111
                },
                {
                    "id": 3,
                    "bfID": "Gam Mus",
                    "RAh": 12.54111111,
                    "DEd": -72.13305556
                },
                {
                    "id": 4,
                    "bfID": "Gam Mus",
                    "RAh": 12.54111111,
                    "DEd": -72.13305556
                },
                {
                    "id": 5,
                    "bfID": "Alp Mus",
                    "RAh": 12.61972222,
                    "DEd": -69.13555556
                },
                {
                    "id": 6,
                    "bfID": "Alp Mus",
                    "RAh": 12.61972222,
                    "DEd": -69.13555556
                },
                {
                    "id": 7,
                    "bfID": "Bet Mus",
                    "RAh": 12.77136111,
                    "DEd": -68.10805556
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Octans",
            "RAh": "21.69125",
            "DEd": "-77.39",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Nu Oct",
                    "RAh": 21.69125,
                    "DEd": -77.39
                },
                {
                    "id": 1,
                    "bfID": "Bet Oct",
                    "RAh": 22.76758333,
                    "DEd": -81.38166667
                },
                {
                    "id": 2,
                    "bfID": "Bet Oct",
                    "RAh": 22.76758333,
                    "DEd": -81.38166667
                },
                {
                    "id": 3,
                    "bfID": "Del Oct",
                    "RAh": 14.44858333,
                    "DEd": -83.66777778
                },
                {
                    "id": 4,
                    "bfID": "Del Oct",
                    "RAh": 14.44858333,
                    "DEd": -83.66777778
                },
                {
                    "id": 5,
                    "bfID": "Nu Oct",
                    "RAh": 21.69125,
                    "DEd": -77.39
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ]
            ]
        },
        {
            "Name": "Apus",
            "RAh": "14.79766667",
            "DEd": "-79.04472222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Aps",
                    "RAh": 14.79766667,
                    "DEd": -79.04472222
                },
                {
                    "id": 1,
                    "bfID": "Gam Aps",
                    "RAh": 16.5575,
                    "DEd": -78.89722222
                },
                {
                    "id": 2,
                    "bfID": "Gam Aps",
                    "RAh": 16.5575,
                    "DEd": -78.89722222
                },
                {
                    "id": 3,
                    "bfID": "Bet Aps",
                    "RAh": 16.71794444,
                    "DEd": -77.5175
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ]
            ]
        },
        {
            "Name": "Ophiuchus",
            "RAh": "17.58225",
            "DEd": "12.56",
            "stars": [
                {
                    "id": 0,
                    "bfID": "55Alp Oph",
                    "RAh": 17.58225,
                    "DEd": 12.56
                },
                {
                    "id": 1,
                    "bfID": "60Bet Oph",
                    "RAh": 17.72455556,
                    "DEd": 4.567222222
                },
                {
                    "id": 2,
                    "bfID": "35Eta Oph",
                    "RAh": 17.17297222,
                    "DEd": -15.72472222
                },
                {
                    "id": 3,
                    "bfID": "60Bet Oph",
                    "RAh": 17.72455556,
                    "DEd": 4.567222222
                },
                {
                    "id": 4,
                    "bfID": "55Alp Oph",
                    "RAh": 17.58225,
                    "DEd": 12.56
                },
                {
                    "id": 5,
                    "bfID": "27Kap Oph",
                    "RAh": 16.96113889,
                    "DEd": 9.375
                },
                {
                    "id": 6,
                    "bfID": "27Kap Oph",
                    "RAh": 16.96113889,
                    "DEd": 9.375
                },
                {
                    "id": 7,
                    "bfID": "2Eps Oph",
                    "RAh": 16.30536111,
                    "DEd": -4.6925
                },
                {
                    "id": 8,
                    "bfID": "2Eps Oph",
                    "RAh": 16.30536111,
                    "DEd": -4.6925
                },
                {
                    "id": 9,
                    "bfID": "13Zet Oph",
                    "RAh": 16.61930556,
                    "DEd": -10.56722222
                },
                {
                    "id": 10,
                    "bfID": "13Zet Oph",
                    "RAh": 16.61930556,
                    "DEd": -10.56722222
                },
                {
                    "id": 11,
                    "bfID": "35Eta Oph",
                    "RAh": 17.17297222,
                    "DEd": -15.72472222
                },
                {
                    "id": 12,
                    "bfID": "35Eta Oph",
                    "RAh": 17.17297222,
                    "DEd": -15.72472222
                },
                {
                    "id": 13,
                    "bfID": "51 Oph",
                    "RAh": 17.52361111,
                    "DEd": -23.96277778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ]
            ]
        },
        {
            "Name": "Pavo",
            "RAh": "20.42747222",
            "DEd": "-56.735",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Pav",
                    "RAh": 20.42747222,
                    "DEd": -56.735
                },
                {
                    "id": 1,
                    "bfID": "Gam Pav",
                    "RAh": 21.44072222,
                    "DEd": -65.36611111
                },
                {
                    "id": 2,
                    "bfID": "Gam Pav",
                    "RAh": 21.44072222,
                    "DEd": -65.36611111
                },
                {
                    "id": 3,
                    "bfID": "Bet Pav",
                    "RAh": 20.74930556,
                    "DEd": -66.20305556
                },
                {
                    "id": 4,
                    "bfID": "Bet Pav",
                    "RAh": 20.74930556,
                    "DEd": -66.20305556
                },
                {
                    "id": 5,
                    "bfID": "Del Pav",
                    "RAh": 20.14544444,
                    "DEd": -66.18194444
                },
                {
                    "id": 6,
                    "bfID": "Del Pav",
                    "RAh": 20.14544444,
                    "DEd": -66.18194444
                },
                {
                    "id": 7,
                    "bfID": "Alp Pav",
                    "RAh": 20.42747222,
                    "DEd": -56.735
                },
                {
                    "id": 8,
                    "bfID": "Del Pav",
                    "RAh": 20.14544444,
                    "DEd": -66.18194444
                },
                {
                    "id": 9,
                    "bfID": "Eps Pav",
                    "RAh": 20.00986111,
                    "DEd": -72.91055556
                },
                {
                    "id": 10,
                    "bfID": "Eps Pav",
                    "RAh": 20.00986111,
                    "DEd": -72.91055556
                },
                {
                    "id": 11,
                    "bfID": "Zet Pav",
                    "RAh": 18.71725,
                    "DEd": -71.42805556
                },
                {
                    "id": 12,
                    "bfID": "Zet Pav",
                    "RAh": 18.71725,
                    "DEd": -71.42805556
                },
                {
                    "id": 13,
                    "bfID": "Kap Pav",
                    "RAh": 18.94916667,
                    "DEd": -67.23361111
                },
                {
                    "id": 14,
                    "bfID": "Kap Pav",
                    "RAh": 18.94916667,
                    "DEd": -67.23361111
                },
                {
                    "id": 15,
                    "bfID": "Del Pav",
                    "RAh": 20.14544444,
                    "DEd": -66.18194444
                },
                {
                    "id": 16,
                    "bfID": "Kap Pav",
                    "RAh": 18.94916667,
                    "DEd": -67.23361111
                },
                {
                    "id": 17,
                    "bfID": "Lam Pav",
                    "RAh": 18.87027778,
                    "DEd": -62.1875
                },
                {
                    "id": 18,
                    "bfID": "Lam Pav",
                    "RAh": 18.87027778,
                    "DEd": -62.1875
                },
                {
                    "id": 19,
                    "bfID": "Xi Pav",
                    "RAh": 18.38711111,
                    "DEd": -61.49388889
                },
                {
                    "id": 20,
                    "bfID": "Xi Pav",
                    "RAh": 18.38711111,
                    "DEd": -61.49388889
                },
                {
                    "id": 21,
                    "bfID": "Pi Pav",
                    "RAh": 18.143,
                    "DEd": -63.66833333
                },
                {
                    "id": 22,
                    "bfID": "Pi Pav",
                    "RAh": 18.143,
                    "DEd": -63.66833333
                },
                {
                    "id": 23,
                    "bfID": "Lam Pav",
                    "RAh": 18.87027778,
                    "DEd": -62.1875
                },
                {
                    "id": 24,
                    "bfID": "Pi Pav",
                    "RAh": 18.143,
                    "DEd": -63.66833333
                },
                {
                    "id": 25,
                    "bfID": "Eta Pav",
                    "RAh": 17.76222222,
                    "DEd": -64.72388889
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ]
            ]
        },
        {
            "Name": "Pegasus",
            "RAh": "0.220611111",
            "DEd": "15.18361111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "88Gam Peg",
                    "RAh": 0.220611111,
                    "DEd": 15.18361111
                },
                {
                    "id": 1,
                    "bfID": "54Alp Peg",
                    "RAh": 23.07936111,
                    "DEd": 15.20527778
                },
                {
                    "id": 2,
                    "bfID": "53Bet Peg",
                    "RAh": 23.06291667,
                    "DEd": 28.08277778
                },
                {
                    "id": 3,
                    "bfID": "44Eta Peg",
                    "RAh": 22.71669444,
                    "DEd": 30.22138889
                },
                {
                    "id": 4,
                    "bfID": "44Eta Peg",
                    "RAh": 22.71669444,
                    "DEd": 30.22138889
                },
                {
                    "id": 5,
                    "bfID": "27Pi 1Peg",
                    "RAh": 22.15377778,
                    "DEd": 33.17222222
                },
                {
                    "id": 6,
                    "bfID": "53Bet Peg",
                    "RAh": 23.06291667,
                    "DEd": 28.08277778
                },
                {
                    "id": 7,
                    "bfID": "48Mu Peg",
                    "RAh": 22.83338889,
                    "DEd": 24.60166667
                },
                {
                    "id": 8,
                    "bfID": "48Mu Peg",
                    "RAh": 22.83338889,
                    "DEd": 24.60166667
                },
                {
                    "id": 9,
                    "bfID": "47Lam Peg",
                    "RAh": 22.77552778,
                    "DEd": 23.56555556
                },
                {
                    "id": 10,
                    "bfID": "47Lam Peg",
                    "RAh": 22.77552778,
                    "DEd": 23.56555556
                },
                {
                    "id": 11,
                    "bfID": "24Iot Peg",
                    "RAh": 22.11686111,
                    "DEd": 25.345
                },
                {
                    "id": 12,
                    "bfID": "24Iot Peg",
                    "RAh": 22.11686111,
                    "DEd": 25.345
                },
                {
                    "id": 13,
                    "bfID": "10Kap Peg",
                    "RAh": 21.74408333,
                    "DEd": 25.645
                },
                {
                    "id": 14,
                    "bfID": "54Alp Peg",
                    "RAh": 23.07936111,
                    "DEd": 15.20527778
                },
                {
                    "id": 15,
                    "bfID": "46Xi Peg",
                    "RAh": 22.77822222,
                    "DEd": 12.17277778
                },
                {
                    "id": 16,
                    "bfID": "46Xi Peg",
                    "RAh": 22.77822222,
                    "DEd": 12.17277778
                },
                {
                    "id": 17,
                    "bfID": "42Zet Peg",
                    "RAh": 22.69102778,
                    "DEd": 10.83138889
                },
                {
                    "id": 18,
                    "bfID": "42Zet Peg",
                    "RAh": 22.69102778,
                    "DEd": 10.83138889
                },
                {
                    "id": 19,
                    "bfID": "26The Peg",
                    "RAh": 22.17,
                    "DEd": 6.197777778
                },
                {
                    "id": 20,
                    "bfID": "26The Peg",
                    "RAh": 22.17,
                    "DEd": 6.197777778
                },
                {
                    "id": 21,
                    "bfID": "8Eps Peg",
                    "RAh": 21.73644444,
                    "DEd": 9.875
                },
                {
                    "id": 22,
                    "bfID": "21Alp And",
                    "RAh": 0.139805556,
                    "DEd": 29.09055556
                },
                {
                    "id": 23,
                    "bfID": "53Bet Peg",
                    "RAh": 23.06291667,
                    "DEd": 28.08277778
                },
                {
                    "id": 24,
                    "bfID": "21Alp And",
                    "RAh": 0.139805556,
                    "DEd": 29.09055556
                },
                {
                    "id": 25,
                    "bfID": "88Gam Peg",
                    "RAh": 0.220611111,
                    "DEd": 15.18361111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ]
            ]
        },
        {
            "Name": "Pictor",
            "RAh": "6.803166667",
            "DEd": "-61.94138889",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Pic",
                    "RAh": 6.803166667,
                    "DEd": -61.94138889
                },
                {
                    "id": 1,
                    "bfID": "Gam Pic",
                    "RAh": 5.830472222,
                    "DEd": -56.16666667
                },
                {
                    "id": 2,
                    "bfID": "Gam Pic",
                    "RAh": 5.830472222,
                    "DEd": -56.16666667
                },
                {
                    "id": 3,
                    "bfID": "Bet Pic",
                    "RAh": 5.788083333,
                    "DEd": -51.06638889
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ]
            ]
        },
        {
            "Name": "Equuleus",
            "RAh": "21.17236111",
            "DEd": "10.13166667",
            "stars": [
                {
                    "id": 0,
                    "bfID": "5Gam Equ",
                    "RAh": 21.17236111,
                    "DEd": 10.13166667
                },
                {
                    "id": 1,
                    "bfID": "7Del Equ",
                    "RAh": 21.24136111,
                    "DEd": 10.00694444
                },
                {
                    "id": 2,
                    "bfID": "7Del Equ",
                    "RAh": 21.24136111,
                    "DEd": 10.00694444
                },
                {
                    "id": 3,
                    "bfID": "10Bet Equ",
                    "RAh": 21.38155556,
                    "DEd": 6.811111111
                },
                {
                    "id": 4,
                    "bfID": "10Bet Equ",
                    "RAh": 21.38155556,
                    "DEd": 6.811111111
                },
                {
                    "id": 5,
                    "bfID": "8Alp Equ",
                    "RAh": 21.26372222,
                    "DEd": 5.247777778
                },
                {
                    "id": 6,
                    "bfID": "8Alp Equ",
                    "RAh": 21.26372222,
                    "DEd": 5.247777778
                },
                {
                    "id": 7,
                    "bfID": "5Gam Equ",
                    "RAh": 21.17236111,
                    "DEd": 10.13166667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Leo Minor",
            "RAh": "10.88852778",
            "DEd": "34.215",
            "stars": [
                {
                    "id": 0,
                    "bfID": "46 LMi",
                    "RAh": 10.88852778,
                    "DEd": 34.215
                },
                {
                    "id": 1,
                    "bfID": "31Bet LMi",
                    "RAh": 10.46472222,
                    "DEd": 36.70722222
                },
                {
                    "id": 2,
                    "bfID": "31Bet LMi",
                    "RAh": 10.46472222,
                    "DEd": 36.70722222
                },
                {
                    "id": 3,
                    "bfID": "21 LMi",
                    "RAh": 10.12383333,
                    "DEd": 35.24472222
                },
                {
                    "id": 4,
                    "bfID": "21 LMi",
                    "RAh": 10.12383333,
                    "DEd": 35.24472222
                },
                {
                    "id": 5,
                    "bfID": "10 LMi",
                    "RAh": 9.570388889,
                    "DEd": 36.3975
                },
                {
                    "id": 6,
                    "bfID": "21 LMi",
                    "RAh": 10.12383333,
                    "DEd": 35.24472222
                },
                {
                    "id": 7,
                    "bfID": "46 LMi",
                    "RAh": 10.88852778,
                    "DEd": 34.215
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Vulpecula",
            "RAh": "19.47841667",
            "DEd": "24.665",
            "stars": [
                {
                    "id": "0",
                    "bfID": "6Alp Vul",
                    "RAh": 19.47841667,
                    "DEd": 24.665
                },
                {
                    "id": "1",
                    "bfID": "13 Vul",
                    "RAh": 19.89102778,
                    "DEd": 24.07972222
                },
                {
                    "id": "2",
                    "bfID": "1 Vul",
                    "RAh": 19.27027778,
                    "DEd": 21.39027778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    0,
                    1
                ]
            ]
        },
        {
            "Name": "Ursa Minor",
            "RAh": "16.76613889",
            "DEd": "82.03722222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "1Alp UMi",
                    "RAh": 2.530194444,
                    "DEd": 89.26416667
                },
                {
                    "id": 1,
                    "bfID": "23Del UMi",
                    "RAh": 17.53691667,
                    "DEd": 86.58638889
                },
                {
                    "id": 2,
                    "bfID": "23Del UMi",
                    "RAh": 17.53691667,
                    "DEd": 86.58638889
                },
                {
                    "id": 3,
                    "bfID": "22Eps UMi",
                    "RAh": 16.76613889,
                    "DEd": 82.03722222
                },
                {
                    "id": 4,
                    "bfID": "22Eps UMi",
                    "RAh": 16.76613889,
                    "DEd": 82.03722222
                },
                {
                    "id": 5,
                    "bfID": "16Zet UMi",
                    "RAh": 15.73430556,
                    "DEd": 77.79444444
                },
                {
                    "id": 6,
                    "bfID": "16Zet UMi",
                    "RAh": 15.73430556,
                    "DEd": 77.79444444
                },
                {
                    "id": 7,
                    "bfID": "21Eta UMi",
                    "RAh": 16.29175,
                    "DEd": 75.75527778
                },
                {
                    "id": 8,
                    "bfID": "21Eta UMi",
                    "RAh": 16.29175,
                    "DEd": 75.75527778
                },
                {
                    "id": 9,
                    "bfID": "13Gam UMi",
                    "RAh": 15.34547222,
                    "DEd": 71.83388889
                },
                {
                    "id": 10,
                    "bfID": "13Gam UMi",
                    "RAh": 15.34547222,
                    "DEd": 71.83388889
                },
                {
                    "id": 11,
                    "bfID": "7Bet UMi",
                    "RAh": 14.84508333,
                    "DEd": 74.15555556
                },
                {
                    "id": 12,
                    "bfID": "7Bet UMi",
                    "RAh": 14.84508333,
                    "DEd": 74.15555556
                },
                {
                    "id": 13,
                    "bfID": "16Zet UMi",
                    "RAh": 15.73430556,
                    "DEd": 77.79444444
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ]
            ]
        },
        {
            "Name": "Phoenix",
            "RAh": "1.13975",
            "DEd": "-55.24583333",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Zet Phe",
                    "RAh": 1.13975,
                    "DEd": -55.24583333
                },
                {
                    "id": 1,
                    "bfID": "Bet Phe",
                    "RAh": 1.101388889,
                    "DEd": -46.71861111
                },
                {
                    "id": 2,
                    "bfID": "Bet Phe",
                    "RAh": 1.101388889,
                    "DEd": -46.71861111
                },
                {
                    "id": 3,
                    "bfID": "Kap Phe",
                    "RAh": 0.436722222,
                    "DEd": -43.68
                },
                {
                    "id": 4,
                    "bfID": "Kap Phe",
                    "RAh": 0.436722222,
                    "DEd": -43.68
                },
                {
                    "id": 5,
                    "bfID": "Zet Phe",
                    "RAh": 1.13975,
                    "DEd": -55.24583333
                },
                {
                    "id": 6,
                    "bfID": "Bet Phe",
                    "RAh": 1.101388889,
                    "DEd": -46.71861111
                },
                {
                    "id": 7,
                    "bfID": "Del Phe",
                    "RAh": 1.520861111,
                    "DEd": -49.07277778
                },
                {
                    "id": 8,
                    "bfID": "Del Phe",
                    "RAh": 1.520861111,
                    "DEd": -49.07277778
                },
                {
                    "id": 9,
                    "bfID": "Psi Phe",
                    "RAh": 1.894111111,
                    "DEd": -46.3025
                },
                {
                    "id": 10,
                    "bfID": "Psi Phe",
                    "RAh": 1.894111111,
                    "DEd": -46.3025
                },
                {
                    "id": 11,
                    "bfID": "Bet Phe",
                    "RAh": 1.101388889,
                    "DEd": -46.71861111
                },
                {
                    "id": 12,
                    "bfID": "Bet Phe",
                    "RAh": 1.101388889,
                    "DEd": -46.71861111
                },
                {
                    "id": 13,
                    "bfID": "Gam Phe",
                    "RAh": 1.47275,
                    "DEd": -43.31833333
                },
                {
                    "id": 14,
                    "bfID": "Gam Phe",
                    "RAh": 1.47275,
                    "DEd": -43.31833333
                },
                {
                    "id": 15,
                    "bfID": "Kap Phe",
                    "RAh": 0.436722222,
                    "DEd": -43.68
                },
                {
                    "id": 16,
                    "bfID": "Kap Phe",
                    "RAh": 0.436722222,
                    "DEd": -43.68
                },
                {
                    "id": 17,
                    "bfID": "Alp Phe",
                    "RAh": 0.438055556,
                    "DEd": -42.30611111
                },
                {
                    "id": 18,
                    "bfID": "Alp Phe",
                    "RAh": 0.438055556,
                    "DEd": -42.30611111
                },
                {
                    "id": 19,
                    "bfID": "Eps Phe",
                    "RAh": 0.156861111,
                    "DEd": -45.7475
                },
                {
                    "id": 20,
                    "bfID": "Eps Phe",
                    "RAh": 0.156861111,
                    "DEd": -45.7475
                },
                {
                    "id": 21,
                    "bfID": "Kap Phe",
                    "RAh": 0.436722222,
                    "DEd": -43.68
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ]
            ]
        },
        {
            "Name": "Pisces",
            "RAh": "1.046972222",
            "DEd": "31.80444444",
            "stars": [
                {
                    "id": 0,
                    "bfID": "69Sig Psc",
                    "RAh": 1.046972222,
                    "DEd": 31.80444444
                },
                {
                    "id": 1,
                    "bfID": "85Phi Psc",
                    "RAh": 1.229138889,
                    "DEd": 24.58361111
                },
                {
                    "id": 2,
                    "bfID": "69Sig Psc",
                    "RAh": 1.046972222,
                    "DEd": 31.80444444
                },
                {
                    "id": 3,
                    "bfID": "90Ups Psc",
                    "RAh": 1.324444444,
                    "DEd": 27.26416667
                },
                {
                    "id": 4,
                    "bfID": "90Ups Psc",
                    "RAh": 1.324444444,
                    "DEd": 27.26416667
                },
                {
                    "id": 5,
                    "bfID": "85Phi Psc",
                    "RAh": 1.229138889,
                    "DEd": 24.58361111
                },
                {
                    "id": 6,
                    "bfID": "85Phi Psc",
                    "RAh": 1.229138889,
                    "DEd": 24.58361111
                },
                {
                    "id": 7,
                    "bfID": "99Eta Psc",
                    "RAh": 1.524722222,
                    "DEd": 15.34583333
                },
                {
                    "id": 8,
                    "bfID": "99Eta Psc",
                    "RAh": 1.524722222,
                    "DEd": 15.34583333
                },
                {
                    "id": 9,
                    "bfID": "110Omi Psc",
                    "RAh": 1.756555556,
                    "DEd": 9.157777778
                },
                {
                    "id": 10,
                    "bfID": "110Omi Psc",
                    "RAh": 1.756555556,
                    "DEd": 9.157777778
                },
                {
                    "id": 11,
                    "bfID": "113Alp Psc",
                    "RAh": 2.034111111,
                    "DEd": 2.763611111
                },
                {
                    "id": 12,
                    "bfID": "113Alp Psc",
                    "RAh": 2.034111111,
                    "DEd": 2.763611111
                },
                {
                    "id": 13,
                    "bfID": "111Xi Psc",
                    "RAh": 1.892583333,
                    "DEd": 3.1875
                },
                {
                    "id": 14,
                    "bfID": "111Xi Psc",
                    "RAh": 1.892583333,
                    "DEd": 3.1875
                },
                {
                    "id": 15,
                    "bfID": "106Nu Psc",
                    "RAh": 1.690527778,
                    "DEd": 5.4875
                },
                {
                    "id": 16,
                    "bfID": "106Nu Psc",
                    "RAh": 1.690527778,
                    "DEd": 5.4875
                },
                {
                    "id": 17,
                    "bfID": "98Mu Psc",
                    "RAh": 1.503083333,
                    "DEd": 6.143888889
                },
                {
                    "id": 18,
                    "bfID": "98Mu Psc",
                    "RAh": 1.503083333,
                    "DEd": 6.143888889
                },
                {
                    "id": 19,
                    "bfID": "71Eps Psc",
                    "RAh": 1.049055556,
                    "DEd": 7.89
                },
                {
                    "id": 20,
                    "bfID": "71Eps Psc",
                    "RAh": 1.049055556,
                    "DEd": 7.89
                },
                {
                    "id": 21,
                    "bfID": "62 Psc",
                    "RAh": 0.804833333,
                    "DEd": 7.3
                },
                {
                    "id": 22,
                    "bfID": "62 Psc",
                    "RAh": 0.804833333,
                    "DEd": 7.3
                },
                {
                    "id": 23,
                    "bfID": "41 Psc",
                    "RAh": 0.343305556,
                    "DEd": 8.190277778
                },
                {
                    "id": 24,
                    "bfID": "41 Psc",
                    "RAh": 0.343305556,
                    "DEd": 8.190277778
                },
                {
                    "id": 25,
                    "bfID": "28Ome Psc",
                    "RAh": 23.98852778,
                    "DEd": 6.863333333
                },
                {
                    "id": 26,
                    "bfID": "28Ome Psc",
                    "RAh": 23.98852778,
                    "DEd": 6.863333333
                },
                {
                    "id": 27,
                    "bfID": "17Iot Psc",
                    "RAh": 23.66583333,
                    "DEd": 5.626388889
                },
                {
                    "id": 28,
                    "bfID": "17Iot Psc",
                    "RAh": 23.66583333,
                    "DEd": 5.626388889
                },
                {
                    "id": 29,
                    "bfID": "18Lam Psc",
                    "RAh": 23.70077778,
                    "DEd": 1.78
                },
                {
                    "id": 30,
                    "bfID": "18Lam Psc",
                    "RAh": 23.70077778,
                    "DEd": 1.78
                },
                {
                    "id": 31,
                    "bfID": "8Kap Psc",
                    "RAh": 23.44888889,
                    "DEd": 1.255555556
                },
                {
                    "id": 32,
                    "bfID": "8Kap Psc",
                    "RAh": 23.44888889,
                    "DEd": 1.255555556
                },
                {
                    "id": 33,
                    "bfID": "6Gam Psc",
                    "RAh": 23.28608333,
                    "DEd": 3.282222222
                },
                {
                    "id": 34,
                    "bfID": "6Gam Psc",
                    "RAh": 23.28608333,
                    "DEd": 3.282222222
                },
                {
                    "id": 35,
                    "bfID": "10The Psc",
                    "RAh": 23.46613889,
                    "DEd": 6.378888889
                },
                {
                    "id": 36,
                    "bfID": "10The Psc",
                    "RAh": 23.46613889,
                    "DEd": 6.378888889
                },
                {
                    "id": 37,
                    "bfID": "17Iot Psc",
                    "RAh": 23.66583333,
                    "DEd": 5.626388889
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ],
                [
                    28,
                    29
                ],
                [
                    30,
                    31
                ],
                [
                    32,
                    33
                ],
                [
                    34,
                    35
                ],
                [
                    36,
                    37
                ]
            ]
        },
        {
            "Name": "Piscis Austrinus",
            "RAh": 22.52508333,
            "DEd": -32.34611111,
            "stars": [
                {
                    "id": 0,
                    "bfID": "24Alp PsA",
                    "RAh": 22.96086111,
                    "DEd": -29.62222222
                },
                {
                    "id": 1,
                    "bfID": "18Eps PsA",
                    "RAh": 22.67761111,
                    "DEd": -27.04361111
                },
                {
                    "id": 2,
                    "bfID": "18Eps PsA",
                    "RAh": 22.67761111,
                    "DEd": -27.04361111
                },
                {
                    "id": 3,
                    "bfID": "12Eta PsA",
                    "RAh": 22.01394444,
                    "DEd": -28.45361111
                },
                {
                    "id": 4,
                    "bfID": "12Eta PsA",
                    "RAh": 22.01394444,
                    "DEd": -28.45361111
                },
                {
                    "id": 5,
                    "bfID": "10The PsA",
                    "RAh": 21.79561111,
                    "DEd": -30.89833333
                },
                {
                    "id": 6,
                    "bfID": "10The PsA",
                    "RAh": 21.79561111,
                    "DEd": -30.89833333
                },
                {
                    "id": 7,
                    "bfID": "15Tau PsA",
                    "RAh": 22.16911111,
                    "DEd": -32.54833333
                },
                {
                    "id": 8,
                    "bfID": "15Tau PsA",
                    "RAh": 22.16911111,
                    "DEd": -32.54833333
                },
                {
                    "id": 9,
                    "bfID": "17Bet PsA",
                    "RAh": 22.52508333,
                    "DEd": -32.34611111
                },
                {
                    "id": 10,
                    "bfID": "17Bet PsA",
                    "RAh": 22.52508333,
                    "DEd": -32.34611111
                },
                {
                    "id": 11,
                    "bfID": "23Del PsA",
                    "RAh": 22.93247222,
                    "DEd": -32.53972222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ]
            ]
        },
        {
            "Name": "Volans",
            "RAh": "7.697",
            "DEd": "-72.60611111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Zet Vol",
                    "RAh": 7.697,
                    "DEd": -72.60611111
                },
                {
                    "id": 1,
                    "bfID": "Gam2Vol",
                    "RAh": 7.145805556,
                    "DEd": -70.49888889
                },
                {
                    "id": 2,
                    "bfID": "Gam2Vol",
                    "RAh": 7.145805556,
                    "DEd": -70.49888889
                },
                {
                    "id": 3,
                    "bfID": "Eps Vol",
                    "RAh": 8.132166667,
                    "DEd": -68.61722222
                },
                {
                    "id": 4,
                    "bfID": "Eps Vol",
                    "RAh": 8.132166667,
                    "DEd": -68.61722222
                },
                {
                    "id": 5,
                    "bfID": "Zet Vol",
                    "RAh": 7.697,
                    "DEd": -72.60611111
                },
                {
                    "id": 6,
                    "bfID": "Eps Vol",
                    "RAh": 8.132166667,
                    "DEd": -68.61722222
                },
                {
                    "id": 7,
                    "bfID": "Del Vol",
                    "RAh": 7.2805,
                    "DEd": -67.95722222
                },
                {
                    "id": 8,
                    "bfID": "Eps Vol",
                    "RAh": 8.132166667,
                    "DEd": -68.61722222
                },
                {
                    "id": 9,
                    "bfID": "Bet Vol",
                    "RAh": 8.428944444,
                    "DEd": -66.13694444
                },
                {
                    "id": 10,
                    "bfID": "Bet Vol",
                    "RAh": 8.428944444,
                    "DEd": -66.13694444
                },
                {
                    "id": 11,
                    "bfID": "Alp Vol",
                    "RAh": 9.040777778,
                    "DEd": -66.39611111
                },
                {
                    "id": 12,
                    "bfID": "Alp Vol",
                    "RAh": 9.040777778,
                    "DEd": -66.39611111
                },
                {
                    "id": 13,
                    "bfID": "Eps Vol",
                    "RAh": 8.132166667,
                    "DEd": -68.61722222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ]
            ]
        },
        {
            "Name": "Reticulum",
            "RAh": "4.240416667",
            "DEd": "-62.47388889",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Ret",
                    "RAh": 4.240416667,
                    "DEd": -62.47388889
                },
                {
                    "id": 1,
                    "bfID": "Eps Ret",
                    "RAh": 4.274694444,
                    "DEd": -59.30194444
                },
                {
                    "id": 2,
                    "bfID": "Eps Ret",
                    "RAh": 4.274694444,
                    "DEd": -59.30194444
                },
                {
                    "id": 3,
                    "bfID": "Del Ret",
                    "RAh": 3.979083333,
                    "DEd": -61.40027778
                },
                {
                    "id": 4,
                    "bfID": "Del Ret",
                    "RAh": 3.979083333,
                    "DEd": -61.40027778
                },
                {
                    "id": 5,
                    "bfID": "Bet Ret",
                    "RAh": 3.736666667,
                    "DEd": -64.80694444
                },
                {
                    "id": 6,
                    "bfID": "Bet Ret",
                    "RAh": 3.736666667,
                    "DEd": -64.80694444
                },
                {
                    "id": 7,
                    "bfID": "Alp Ret",
                    "RAh": 4.240416667,
                    "DEd": -62.47388889
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Sagittarius",
            "RAh": "18.34991667",
            "DEd": "-29.82805556",
            "stars": [
                {
                    "id": 0,
                    "bfID": "19Del Sgr",
                    "RAh": 18.34991667,
                    "DEd": -29.82805556
                },
                {
                    "id": 1,
                    "bfID": "22Lam Sgr",
                    "RAh": 18.46616667,
                    "DEd": -25.42166667
                },
                {
                    "id": 2,
                    "bfID": "Eta Sgr",
                    "RAh": 18.29377778,
                    "DEd": -36.76166667
                },
                {
                    "id": 3,
                    "bfID": "20Eps Sgr",
                    "RAh": 18.40286111,
                    "DEd": -34.38472222
                },
                {
                    "id": 4,
                    "bfID": "20Eps Sgr",
                    "RAh": 18.40286111,
                    "DEd": -34.38472222
                },
                {
                    "id": 5,
                    "bfID": "10Gam2Sgr",
                    "RAh": 18.09680556,
                    "DEd": -30.42416667
                },
                {
                    "id": 6,
                    "bfID": "10Gam2Sgr",
                    "RAh": 18.09680556,
                    "DEd": -30.42416667
                },
                {
                    "id": 7,
                    "bfID": "3 Sgr",
                    "RAh": 17.79266667,
                    "DEd": -27.83083333
                },
                {
                    "id": 8,
                    "bfID": "10Gam2Sgr",
                    "RAh": 18.09680556,
                    "DEd": -30.42416667
                },
                {
                    "id": 9,
                    "bfID": "19Del Sgr",
                    "RAh": 18.34991667,
                    "DEd": -29.82805556
                },
                {
                    "id": 10,
                    "bfID": "19Del Sgr",
                    "RAh": 18.34991667,
                    "DEd": -29.82805556
                },
                {
                    "id": 11,
                    "bfID": "20Eps Sgr",
                    "RAh": 18.40286111,
                    "DEd": -34.38472222
                },
                {
                    "id": 12,
                    "bfID": "20Eps Sgr",
                    "RAh": 18.40286111,
                    "DEd": -34.38472222
                },
                {
                    "id": 13,
                    "bfID": "38Zet Sgr",
                    "RAh": 19.04352778,
                    "DEd": -29.88027778
                },
                {
                    "id": 14,
                    "bfID": "38Zet Sgr",
                    "RAh": 19.04352778,
                    "DEd": -29.88027778
                },
                {
                    "id": 15,
                    "bfID": "27Phi Sgr",
                    "RAh": 18.76094444,
                    "DEd": -26.99083333
                },
                {
                    "id": 16,
                    "bfID": "27Phi Sgr",
                    "RAh": 18.76094444,
                    "DEd": -26.99083333
                },
                {
                    "id": 17,
                    "bfID": "19Del Sgr",
                    "RAh": 18.34991667,
                    "DEd": -29.82805556
                },
                {
                    "id": 18,
                    "bfID": "27Phi Sgr",
                    "RAh": 18.76094444,
                    "DEd": -26.99083333
                },
                {
                    "id": 19,
                    "bfID": "22Lam Sgr",
                    "RAh": 18.46616667,
                    "DEd": -25.42166667
                },
                {
                    "id": 20,
                    "bfID": "22Lam Sgr",
                    "RAh": 18.46616667,
                    "DEd": -25.42166667
                },
                {
                    "id": 21,
                    "bfID": "13Mu Sgr",
                    "RAh": 18.22938889,
                    "DEd": -21.05888889
                },
                {
                    "id": 22,
                    "bfID": "38Zet Sgr",
                    "RAh": 19.04352778,
                    "DEd": -29.88027778
                },
                {
                    "id": 23,
                    "bfID": "40Tau Sgr",
                    "RAh": 19.11566667,
                    "DEd": -27.67055556
                },
                {
                    "id": 24,
                    "bfID": "40Tau Sgr",
                    "RAh": 19.11566667,
                    "DEd": -27.67055556
                },
                {
                    "id": 25,
                    "bfID": "34Sig Sgr",
                    "RAh": 18.92108333,
                    "DEd": -26.29666667
                },
                {
                    "id": 26,
                    "bfID": "34Sig Sgr",
                    "RAh": 18.92108333,
                    "DEd": -26.29666667
                },
                {
                    "id": 27,
                    "bfID": "27Phi Sgr",
                    "RAh": 18.76094444,
                    "DEd": -26.99083333
                },
                {
                    "id": 28,
                    "bfID": "34Sig Sgr",
                    "RAh": 18.92108333,
                    "DEd": -26.29666667
                },
                {
                    "id": 29,
                    "bfID": "37Xi 2Sgr",
                    "RAh": 18.96216667,
                    "DEd": -21.10666667
                },
                {
                    "id": 30,
                    "bfID": "37Xi 2Sgr",
                    "RAh": 18.96216667,
                    "DEd": -21.10666667
                },
                {
                    "id": 31,
                    "bfID": "39Omi Sgr",
                    "RAh": 19.07805556,
                    "DEd": -21.74166667
                },
                {
                    "id": 32,
                    "bfID": "39Omi Sgr",
                    "RAh": 19.07805556,
                    "DEd": -21.74166667
                },
                {
                    "id": 33,
                    "bfID": "43 Sgr",
                    "RAh": 19.29391667,
                    "DEd": -18.95305556
                },
                {
                    "id": 34,
                    "bfID": "43 Sgr",
                    "RAh": 19.29391667,
                    "DEd": -18.95305556
                },
                {
                    "id": 35,
                    "bfID": "44Rho1Sgr",
                    "RAh": 19.36122222,
                    "DEd": -17.84722222
                },
                {
                    "id": 36,
                    "bfID": "40Tau Sgr",
                    "RAh": 19.11566667,
                    "DEd": -27.67055556
                },
                {
                    "id": 37,
                    "bfID": "51 Sgr",
                    "RAh": 19.60047222,
                    "DEd": -24.71916667
                },
                {
                    "id": 38,
                    "bfID": "51 Sgr",
                    "RAh": 19.60047222,
                    "DEd": -24.71916667
                },
                {
                    "id": 39,
                    "bfID": "62 Sgr",
                    "RAh": 20.04430556,
                    "DEd": -27.70972222
                },
                {
                    "id": 40,
                    "bfID": "62 Sgr",
                    "RAh": 20.04430556,
                    "DEd": -27.70972222
                },
                {
                    "id": 41,
                    "bfID": "The1Sgr",
                    "RAh": 19.99561111,
                    "DEd": -35.27638889
                },
                {
                    "id": 42,
                    "bfID": "The1Sgr",
                    "RAh": 19.99561111,
                    "DEd": -35.27638889
                },
                {
                    "id": 43,
                    "bfID": "Iot Sgr",
                    "RAh": 19.92102778,
                    "DEd": -41.86833333
                },
                {
                    "id": 44,
                    "bfID": "Iot Sgr",
                    "RAh": 19.92102778,
                    "DEd": -41.86833333
                },
                {
                    "id": 45,
                    "bfID": "Alp Sgr",
                    "RAh": 19.39811111,
                    "DEd": -40.61611111
                },
                {
                    "id": 46,
                    "bfID": "Iot Sgr",
                    "RAh": 19.92102778,
                    "DEd": -41.86833333
                },
                {
                    "id": 47,
                    "bfID": "Bet2Sgr",
                    "RAh": 19.387,
                    "DEd": -44.79972222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ],
                [
                    28,
                    29
                ],
                [
                    30,
                    31
                ],
                [
                    32,
                    33
                ],
                [
                    34,
                    35
                ],
                [
                    36,
                    37
                ],
                [
                    38,
                    39
                ],
                [
                    40,
                    41
                ],
                [
                    42,
                    43
                ],
                [
                    44,
                    45
                ],
                [
                    46,
                    47
                ]
            ]
        },
        {
            "Name": "Serpens",
            "RAh": "15.827",
            "DEd": "-3.430277778",
            "stars": [
                {
                    "id": 0,
                    "bfID": "32Mu Ser",
                    "RAh": 15.827,
                    "DEd": -3.430277778
                },
                {
                    "id": 1,
                    "bfID": "37Eps Ser",
                    "RAh": 15.84694444,
                    "DEd": 4.477777778
                },
                {
                    "id": 2,
                    "bfID": "37Eps Ser",
                    "RAh": 15.84694444,
                    "DEd": 4.477777778
                },
                {
                    "id": 3,
                    "bfID": "24Alp Ser",
                    "RAh": 15.73780556,
                    "DEd": 6.425555556
                },
                {
                    "id": 4,
                    "bfID": "24Alp Ser",
                    "RAh": 15.73780556,
                    "DEd": 6.425555556
                },
                {
                    "id": 5,
                    "bfID": "13Del Ser",
                    "RAh": 15.58002778,
                    "DEd": 10.5375
                },
                {
                    "id": 6,
                    "bfID": "13Del Ser",
                    "RAh": 15.58002778,
                    "DEd": 10.5375
                },
                {
                    "id": 7,
                    "bfID": "28Bet Ser",
                    "RAh": 15.76980556,
                    "DEd": 15.42194444
                },
                {
                    "id": 8,
                    "bfID": "28Bet Ser",
                    "RAh": 15.76980556,
                    "DEd": 15.42194444
                },
                {
                    "id": 9,
                    "bfID": "41Gam Ser",
                    "RAh": 15.94088889,
                    "DEd": 15.66166667
                },
                {
                    "id": 10,
                    "bfID": "41Gam Ser",
                    "RAh": 15.94088889,
                    "DEd": 15.66166667
                },
                {
                    "id": 11,
                    "bfID": "35Kap Ser",
                    "RAh": 15.81233333,
                    "DEd": 18.14166667
                },
                {
                    "id": 12,
                    "bfID": "35Kap Ser",
                    "RAh": 15.81233333,
                    "DEd": 18.14166667
                },
                {
                    "id": 13,
                    "bfID": "28Bet Ser",
                    "RAh": 15.76980556,
                    "DEd": 15.42194444
                },
                {
                    "id": 14,
                    "bfID": "63The1Ser",
                    "RAh": 18.937,
                    "DEd": 4.203611111
                },
                {
                    "id": 15,
                    "bfID": "58Eta Ser",
                    "RAh": 18.35516667,
                    "DEd": -2.898888889
                },
                {
                    "id": 16,
                    "bfID": "58Eta Ser",
                    "RAh": 18.35516667,
                    "DEd": -2.898888889
                },
                {
                    "id": 17,
                    "bfID": "56Omi Ser",
                    "RAh": 17.69025,
                    "DEd": -12.87527778
                },
                {
                    "id": 18,
                    "bfID": "56Omi Ser",
                    "RAh": 17.69025,
                    "DEd": -12.87527778
                },
                {
                    "id": 19,
                    "bfID": "55Xi Ser",
                    "RAh": 17.62644444,
                    "DEd": -15.39861111
                },
                {
                    "id": 20,
                    "bfID": "55Xi Ser",
                    "RAh": 17.62644444,
                    "DEd": -15.39861111
                },
                {
                    "id": 21,
                    "bfID": "53Nu Ser",
                    "RAh": 17.34713889,
                    "DEd": -12.84694444
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ]
            ]
        },
        {
            "Name": "Sextans",
            "RAh": "10.50486111",
            "DEd": "-0.636944444",
            "stars": [
                {
                    "id": 0,
                    "bfID": "30Bet Sex",
                    "RAh": 10.50486111,
                    "DEd": -0.636944444
                },
                {
                    "id": 1,
                    "bfID": "15Alp Sex",
                    "RAh": 10.13230556,
                    "DEd": -0.371666667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ]
            ]
        },
        {
            "Name": "Mensa",
            "RAh": "5.531361111",
            "DEd": "-76.34111111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Gam Men",
                    "RAh": 5.531361111,
                    "DEd": -76.34111111
                },
                {
                    "id": 1,
                    "bfID": "Mu Men",
                    "RAh": 4.71775,
                    "DEd": -70.93111111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ]
            ]
        },
        {
            "Name": "Taurus",
            "RAh": "5.438194444",
            "DEd": "28.6075",
            "stars": [
                {
                    "id": 0,
                    "bfID": "112Bet Tau",
                    "RAh": 5.438194444,
                    "DEd": 28.6075
                },
                {
                    "id": 1,
                    "bfID": "94Tau Tau",
                    "RAh": 4.704083333,
                    "DEd": 22.95694444
                },
                {
                    "id": 2,
                    "bfID": "94Tau Tau",
                    "RAh": 4.704083333,
                    "DEd": 22.95694444
                },
                {
                    "id": 3,
                    "bfID": "74Eps Tau",
                    "RAh": 4.476944444,
                    "DEd": 19.18027778
                },
                {
                    "id": 4,
                    "bfID": "87Alp Tau",
                    "RAh": 4.598666667,
                    "DEd": 16.50916667
                },
                {
                    "id": 5,
                    "bfID": "123Zet Tau",
                    "RAh": 5.627416667,
                    "DEd": 21.1425
                },
                {
                    "id": 6,
                    "bfID": "54Gam Tau",
                    "RAh": 4.329888889,
                    "DEd": 15.6275
                },
                {
                    "id": 7,
                    "bfID": "61Del1Tau",
                    "RAh": 4.38225,
                    "DEd": 17.5425
                },
                {
                    "id": 8,
                    "bfID": "54Gam Tau",
                    "RAh": 4.329888889,
                    "DEd": 15.6275
                },
                {
                    "id": 9,
                    "bfID": "35Lam Tau",
                    "RAh": 4.011333333,
                    "DEd": 12.49027778
                },
                {
                    "id": 10,
                    "bfID": "35Lam Tau",
                    "RAh": 4.011333333,
                    "DEd": 12.49027778
                },
                {
                    "id": 11,
                    "bfID": "1Omi Tau",
                    "RAh": 3.413555556,
                    "DEd": 9.028888889
                },
                {
                    "id": 12,
                    "bfID": "87Alp Tau",
                    "RAh": 4.598666667,
                    "DEd": 16.50916667
                },
                {
                    "id": 13,
                    "bfID": "74Eps Tau",
                    "RAh": 4.476944444,
                    "DEd": 19.18027778
                },
                {
                    "id": 14,
                    "bfID": "87Alp Tau",
                    "RAh": 4.598666667,
                    "DEd": 16.50916667
                },
                {
                    "id": 15,
                    "bfID": "78The2Tau",
                    "RAh": 4.477694444,
                    "DEd": 15.87083333
                },
                {
                    "id": 16,
                    "bfID": "78The2Tau",
                    "RAh": 4.477694444,
                    "DEd": 15.87083333
                },
                {
                    "id": 17,
                    "bfID": "54Gam Tau",
                    "RAh": 4.329888889,
                    "DEd": 15.6275
                },
                {
                    "id": 18,
                    "bfID": "74Eps Tau",
                    "RAh": 4.476944444,
                    "DEd": 19.18027778
                },
                {
                    "id": 19,
                    "bfID": "68Del3Tau",
                    "RAh": 4.424833333,
                    "DEd": 17.92805556
                },
                {
                    "id": 20,
                    "bfID": "68Del3Tau",
                    "RAh": 4.424833333,
                    "DEd": 17.92805556
                },
                {
                    "id": 21,
                    "bfID": "61Del1Tau",
                    "RAh": 4.38225,
                    "DEd": 17.5425
                },
                {
                    "id": 22,
                    "bfID": "61Del1Tau",
                    "RAh": 4.38225,
                    "DEd": 17.5425
                },
                {
                    "id": 23,
                    "bfID": "27 Tau",
                    "RAh": 3.819361111,
                    "DEd": 24.05333333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ]
            ]
        },
        {
            "Name": "Telescopium",
            "RAh": "18.48052778",
            "DEd": "-49.07083333",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Zet Tel",
                    "RAh": 18.48052778,
                    "DEd": -49.07083333
                },
                {
                    "id": 1,
                    "bfID": "Alp Tel",
                    "RAh": 18.44955556,
                    "DEd": -45.96833333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ]
            ]
        },
        {
            "Name": "Tucana",
            "RAh": "22.30836111",
            "DEd": "-60.25972222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Tuc",
                    "RAh": 22.30836111,
                    "DEd": -60.25972222
                },
                {
                    "id": 1,
                    "bfID": "Gam Tuc",
                    "RAh": 23.2905,
                    "DEd": -58.23583333
                },
                {
                    "id": 2,
                    "bfID": "Gam Tuc",
                    "RAh": 23.2905,
                    "DEd": -58.23583333
                },
                {
                    "id": 3,
                    "bfID": "Zet Tuc",
                    "RAh": 0.334527778,
                    "DEd": -64.87472222
                },
                {
                    "id": 4,
                    "bfID": "Gam Tuc",
                    "RAh": 23.2905,
                    "DEd": -58.23583333
                },
                {
                    "id": 5,
                    "bfID": "Bet1Tuc",
                    "RAh": 0.52575,
                    "DEd": -62.95805556
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ]
            ]
        },
        {
            "Name": "Triangulum",
            "RAh": "2.265611111",
            "DEd": "33.35888889",
            "stars": [
                {
                    "id": 0,
                    "bfID": "7 Tri",
                    "RAh": 2.265611111,
                    "DEd": 33.35888889
                },
                {
                    "id": 1,
                    "bfID": "4Bet Tri",
                    "RAh": 2.159055556,
                    "DEd": 34.98722222
                },
                {
                    "id": 2,
                    "bfID": "4Bet Tri",
                    "RAh": 2.159055556,
                    "DEd": 34.98722222
                },
                {
                    "id": 3,
                    "bfID": "2Alp Tri",
                    "RAh": 1.884694444,
                    "DEd": 29.57888889
                },
                {
                    "id": 4,
                    "bfID": "2Alp Tri",
                    "RAh": 1.884694444,
                    "DEd": 29.57888889
                },
                {
                    "id": 5,
                    "bfID": "7 Tri",
                    "RAh": 2.265611111,
                    "DEd": 33.35888889
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ]
            ]
        },
        {
            "Name": "Triangulum Australe",
            "RAh": "16.81108333",
            "DEd": "-69.02777778",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp TrA",
                    "RAh": 16.81108333,
                    "DEd": -69.02777778
                },
                {
                    "id": 1,
                    "bfID": "Gam TrA",
                    "RAh": 15.31516667,
                    "DEd": -68.67944444
                },
                {
                    "id": 2,
                    "bfID": "Gam TrA",
                    "RAh": 15.31516667,
                    "DEd": -68.67944444
                },
                {
                    "id": 3,
                    "bfID": "Bet TrA",
                    "RAh": 15.91902778,
                    "DEd": -63.43055556
                },
                {
                    "id": 4,
                    "bfID": "Bet TrA",
                    "RAh": 15.91902778,
                    "DEd": -63.43055556
                },
                {
                    "id": 5,
                    "bfID": "Alp TrA",
                    "RAh": 16.81108333,
                    "DEd": -69.02777778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ]
            ]
        },
        {
            "Name": "Aquarius",
            "RAh": "21.52597222",
            "DEd": "-5.571111111",
            "stars": [
                {
                    "id": 0,
                    "bfID": "22Bet Aqr",
                    "RAh": 21.52597222,
                    "DEd": -5.571111111
                },
                {
                    "id": 1,
                    "bfID": "34Alp Aqr",
                    "RAh": 22.09638889,
                    "DEd": -0.319722222
                },
                {
                    "id": 2,
                    "bfID": "34Alp Aqr",
                    "RAh": 22.09638889,
                    "DEd": -0.319722222
                },
                {
                    "id": 3,
                    "bfID": "48Gam Aqr",
                    "RAh": 22.36094444,
                    "DEd": -1.387222222
                },
                {
                    "id": 4,
                    "bfID": "48Gam Aqr",
                    "RAh": 22.36094444,
                    "DEd": -1.387222222
                },
                {
                    "id": 5,
                    "bfID": "55Zet1Aqr",
                    "RAh": 22.48047222,
                    "DEd": -0.020277778
                },
                {
                    "id": 6,
                    "bfID": "55Zet1Aqr",
                    "RAh": 22.48047222,
                    "DEd": -0.020277778
                },
                {
                    "id": 7,
                    "bfID": "62Eta Aqr",
                    "RAh": 22.58927778,
                    "DEd": -0.1175
                },
                {
                    "id": 8,
                    "bfID": "62Eta Aqr",
                    "RAh": 22.58927778,
                    "DEd": -0.1175
                },
                {
                    "id": 9,
                    "bfID": "73Lam Aqr",
                    "RAh": 22.87691667,
                    "DEd": -7.579722222
                },
                {
                    "id": 10,
                    "bfID": "73Lam Aqr",
                    "RAh": 22.87691667,
                    "DEd": -7.579722222
                },
                {
                    "id": 11,
                    "bfID": "91Psi1Aqr",
                    "RAh": 23.26486111,
                    "DEd": -9.087777778
                },
                {
                    "id": 12,
                    "bfID": "91Psi1Aqr",
                    "RAh": 23.26486111,
                    "DEd": -9.087777778
                },
                {
                    "id": 13,
                    "bfID": "98 Aqr",
                    "RAh": 23.38283333,
                    "DEd": -20.10055556
                },
                {
                    "id": 14,
                    "bfID": "34Alp Aqr",
                    "RAh": 22.09638889,
                    "DEd": -0.319722222
                },
                {
                    "id": 15,
                    "bfID": "43The Aqr",
                    "RAh": 22.28055556,
                    "DEd": -7.783333333
                },
                {
                    "id": 16,
                    "bfID": "43The Aqr",
                    "RAh": 22.28055556,
                    "DEd": -7.783333333
                },
                {
                    "id": 17,
                    "bfID": "33Iot Aqr",
                    "RAh": 22.10727778,
                    "DEd": -13.86972222
                },
                {
                    "id": 18,
                    "bfID": "43The Aqr",
                    "RAh": 22.28055556,
                    "DEd": -7.783333333
                },
                {
                    "id": 19,
                    "bfID": "57Sig Aqr",
                    "RAh": 22.51077778,
                    "DEd": -10.67805556
                },
                {
                    "id": 20,
                    "bfID": "57Sig Aqr",
                    "RAh": 22.51077778,
                    "DEd": -10.67805556
                },
                {
                    "id": 21,
                    "bfID": "71Tau2Aqr",
                    "RAh": 22.82652778,
                    "DEd": -13.5925
                },
                {
                    "id": 22,
                    "bfID": "71Tau2Aqr",
                    "RAh": 22.82652778,
                    "DEd": -13.5925
                },
                {
                    "id": 23,
                    "bfID": "76Del Aqr",
                    "RAh": 22.91083333,
                    "DEd": -15.82083333
                },
                {
                    "id": 24,
                    "bfID": "76Del Aqr",
                    "RAh": 22.91083333,
                    "DEd": -15.82083333
                },
                {
                    "id": 25,
                    "bfID": "88 Aqr",
                    "RAh": 23.15744444,
                    "DEd": -21.1725
                },
                {
                    "id": 26,
                    "bfID": "2Eps Aqr",
                    "RAh": 20.79461111,
                    "DEd": -9.495833333
                },
                {
                    "id": 27,
                    "bfID": "22Bet Aqr",
                    "RAh": 21.52597222,
                    "DEd": -5.571111111
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ]
            ]
        },
        {
            "Name": "Scutum",
            "RAh": "18.78625",
            "DEd": "-4.747777778",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Bet Sct",
                    "RAh": 18.78625,
                    "DEd": -4.747777778
                },
                {
                    "id": 1,
                    "bfID": "",
                    "RAh": 18.79138889,
                    "DEd": -5.705
                },
                {
                    "id": 2,
                    "bfID": "",
                    "RAh": 18.79138889,
                    "DEd": -5.705
                },
                {
                    "id": 3,
                    "bfID": "Gam Sct",
                    "RAh": 18.48663889,
                    "DEd": -14.56583333
                },
                {
                    "id": 4,
                    "bfID": "Gam Sct",
                    "RAh": 18.48663889,
                    "DEd": -14.56583333
                },
                {
                    "id": 5,
                    "bfID": "Alp Sct",
                    "RAh": 18.58677778,
                    "DEd": -8.244166667
                },
                {
                    "id": 6,
                    "bfID": "Alp Sct",
                    "RAh": 18.58677778,
                    "DEd": -8.244166667
                },
                {
                    "id": 7,
                    "bfID": "Bet Sct",
                    "RAh": 18.78625,
                    "DEd": -4.747777778
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ]
            ]
        },
        {
            "Name": "Carina",
            "RAh": "9.22",
            "DEd": "-69.71722222",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Bet Car",
                    "RAh": 9.22,
                    "DEd": -69.71722222
                },
                {
                    "id": 1,
                    "bfID": "Ome Car",
                    "RAh": 10.22894444,
                    "DEd": -70.03805556
                },
                {
                    "id": 2,
                    "bfID": "Ome Car",
                    "RAh": 10.22894444,
                    "DEd": -70.03805556
                },
                {
                    "id": 3,
                    "bfID": "The Car",
                    "RAh": 10.71594444,
                    "DEd": -64.39444444
                },
                {
                    "id": 4,
                    "bfID": "The Car",
                    "RAh": 10.71594444,
                    "DEd": -64.39444444
                },
                {
                    "id": 5,
                    "bfID": "",
                    "RAh": 10.72558333,
                    "DEd": -60.56666667
                },
                {
                    "id": 6,
                    "bfID": "",
                    "RAh": 10.72558333,
                    "DEd": -60.56666667
                },
                {
                    "id": 7,
                    "bfID": "",
                    "RAh": 11.14316667,
                    "DEd": -58.975
                },
                {
                    "id": 8,
                    "bfID": "",
                    "RAh": 11.14316667,
                    "DEd": -58.975
                },
                {
                    "id": 9,
                    "bfID": "",
                    "RAh": 10.89155556,
                    "DEd": -58.85333333
                },
                {
                    "id": 10,
                    "bfID": "",
                    "RAh": 10.89155556,
                    "DEd": -58.85333333
                },
                {
                    "id": 11,
                    "bfID": "",
                    "RAh": 10.46463889,
                    "DEd": -58.73944444
                },
                {
                    "id": 12,
                    "bfID": "",
                    "RAh": 10.46463889,
                    "DEd": -58.73944444
                },
                {
                    "id": 13,
                    "bfID": "",
                    "RAh": 10.28472222,
                    "DEd": -61.33222222
                },
                {
                    "id": 14,
                    "bfID": "",
                    "RAh": 10.28472222,
                    "DEd": -61.33222222
                },
                {
                    "id": 15,
                    "bfID": "Iot Car",
                    "RAh": 9.284833333,
                    "DEd": -59.27527778
                },
                {
                    "id": 16,
                    "bfID": "",
                    "RAh": 8.676944444,
                    "DEd": -59.76111111
                },
                {
                    "id": 17,
                    "bfID": "Eps Car",
                    "RAh": 8.375222222,
                    "DEd": -59.50972222
                },
                {
                    "id": 18,
                    "bfID": "Eps Car",
                    "RAh": 8.375222222,
                    "DEd": -59.50972222
                },
                {
                    "id": 19,
                    "bfID": "Alp Car",
                    "RAh": 6.399194444,
                    "DEd": -52.69583333
                },
                {
                    "id": 20,
                    "bfID": "",
                    "RAh": 9.182777778,
                    "DEd": -58.96694444
                },
                {
                    "id": 21,
                    "bfID": "Iot Car",
                    "RAh": 9.284833333,
                    "DEd": -59.27527778
                },
                {
                    "id": 22,
                    "bfID": "",
                    "RAh": 9.182777778,
                    "DEd": -58.96694444
                },
                {
                    "id": 23,
                    "bfID": "",
                    "RAh": 8.676944444,
                    "DEd": -59.76111111
                },
                {
                    "id": 24,
                    "bfID": "Alp Car",
                    "RAh": 6.399194444,
                    "DEd": -52.69583333
                },
                {
                    "id": 25,
                    "bfID": "Nu Pup",
                    "RAh": 6.629361111,
                    "DEd": -43.19611111
                },
                {
                    "id": 26,
                    "bfID": "Eps Car",
                    "RAh": 8.375222222,
                    "DEd": -59.50972222
                },
                {
                    "id": 27,
                    "bfID": "Zet Pup",
                    "RAh": 8.05975,
                    "DEd": -40.00333333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ]
            ]
        },
        {
            "Name": "Centaurus",
            "RAh": "14.65997222",
            "DEd": "-60.83527778",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp1Cen",
                    "RAh": 14.65997222,
                    "DEd": -60.83527778
                },
                {
                    "id": 1,
                    "bfID": "Bet Cen",
                    "RAh": 14.06372222,
                    "DEd": -60.37305556
                },
                {
                    "id": 2,
                    "bfID": "Bet Cen",
                    "RAh": 14.06372222,
                    "DEd": -60.37305556
                },
                {
                    "id": 3,
                    "bfID": "Eps Cen",
                    "RAh": 13.66477778,
                    "DEd": -53.46638889
                },
                {
                    "id": 4,
                    "bfID": "Eps Cen",
                    "RAh": 13.66477778,
                    "DEd": -53.46638889
                },
                {
                    "id": 5,
                    "bfID": "Zet Cen",
                    "RAh": 13.92566667,
                    "DEd": -47.28833333
                },
                {
                    "id": 6,
                    "bfID": "Zet Cen",
                    "RAh": 13.92566667,
                    "DEd": -47.28833333
                },
                {
                    "id": 7,
                    "bfID": "Ups1Cen",
                    "RAh": 13.978,
                    "DEd": -44.80361111
                },
                {
                    "id": 8,
                    "bfID": "Ups1Cen",
                    "RAh": 13.978,
                    "DEd": -44.80361111
                },
                {
                    "id": 9,
                    "bfID": "Mu Cen",
                    "RAh": 13.82694444,
                    "DEd": -42.47388889
                },
                {
                    "id": 10,
                    "bfID": "Mu Cen",
                    "RAh": 13.82694444,
                    "DEd": -42.47388889
                },
                {
                    "id": 11,
                    "bfID": "Nu Cen",
                    "RAh": 13.82508333,
                    "DEd": -41.68777778
                },
                {
                    "id": 12,
                    "bfID": "Nu Cen",
                    "RAh": 13.82508333,
                    "DEd": -41.68777778
                },
                {
                    "id": 13,
                    "bfID": "",
                    "RAh": 13.51741667,
                    "DEd": -39.4075
                },
                {
                    "id": 14,
                    "bfID": "",
                    "RAh": 13.51741667,
                    "DEd": -39.4075
                },
                {
                    "id": 15,
                    "bfID": "Iot Cen",
                    "RAh": 13.34327778,
                    "DEd": -36.71222222
                },
                {
                    "id": 16,
                    "bfID": "Nu Cen",
                    "RAh": 13.82508333,
                    "DEd": -41.68777778
                },
                {
                    "id": 17,
                    "bfID": "5The Cen",
                    "RAh": 14.11138889,
                    "DEd": -36.37
                },
                {
                    "id": 18,
                    "bfID": "Mu Cen",
                    "RAh": 13.82694444,
                    "DEd": -42.47388889
                },
                {
                    "id": 19,
                    "bfID": "Eta Cen",
                    "RAh": 14.59177778,
                    "DEd": -42.15777778
                },
                {
                    "id": 20,
                    "bfID": "Eta Cen",
                    "RAh": 14.59177778,
                    "DEd": -42.15777778
                },
                {
                    "id": 21,
                    "bfID": "Kap Cen",
                    "RAh": 14.98602778,
                    "DEd": -42.10416667
                },
                {
                    "id": 22,
                    "bfID": "Zet Cen",
                    "RAh": 13.92566667,
                    "DEd": -47.28833333
                },
                {
                    "id": 23,
                    "bfID": "Gam Cen",
                    "RAh": 12.69194444,
                    "DEd": -48.95972222
                },
                {
                    "id": 24,
                    "bfID": "Gam Cen",
                    "RAh": 12.69194444,
                    "DEd": -48.95972222
                },
                {
                    "id": 25,
                    "bfID": "Sig Cen",
                    "RAh": 12.46733333,
                    "DEd": -50.23055556
                },
                {
                    "id": 26,
                    "bfID": "Sig Cen",
                    "RAh": 12.46733333,
                    "DEd": -50.23055556
                },
                {
                    "id": 27,
                    "bfID": "Del Cen",
                    "RAh": 12.13930556,
                    "DEd": -50.7225
                },
                {
                    "id": 28,
                    "bfID": "Del Cen",
                    "RAh": 12.13930556,
                    "DEd": -50.7225
                },
                {
                    "id": 29,
                    "bfID": "",
                    "RAh": 11.57936111,
                    "DEd": -54.26416667
                },
                {
                    "id": 30,
                    "bfID": "",
                    "RAh": 11.57936111,
                    "DEd": -54.26416667
                },
                {
                    "id": 31,
                    "bfID": "Lam Cen",
                    "RAh": 11.59633333,
                    "DEd": -63.01972222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ],
                [
                    28,
                    29
                ],
                [
                    30,
                    31
                ]
            ]
        },
        {
            "Name": "Dorado",
            "RAh": "5.746222222",
            "DEd": "-65.73555556",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Del Dor",
                    "RAh": 5.746222222,
                    "DEd": -65.73555556
                },
                {
                    "id": 1,
                    "bfID": "",
                    "RAh": 5.901694444,
                    "DEd": -63.09
                },
                {
                    "id": 2,
                    "bfID": "",
                    "RAh": 5.901694444,
                    "DEd": -63.09
                },
                {
                    "id": 3,
                    "bfID": "Bet Dor",
                    "RAh": 5.560416667,
                    "DEd": -62.48972222
                },
                {
                    "id": 4,
                    "bfID": "Bet Dor",
                    "RAh": 5.560416667,
                    "DEd": -62.48972222
                },
                {
                    "id": 5,
                    "bfID": "Del Dor",
                    "RAh": 5.746222222,
                    "DEd": -65.73555556
                },
                {
                    "id": 6,
                    "bfID": "Bet Dor",
                    "RAh": 5.560416667,
                    "DEd": -62.48972222
                },
                {
                    "id": 7,
                    "bfID": "Alp Dor",
                    "RAh": 4.566611111,
                    "DEd": -55.045
                },
                {
                    "id": 8,
                    "bfID": "Alp Dor",
                    "RAh": 4.566611111,
                    "DEd": -55.045
                },
                {
                    "id": 9,
                    "bfID": "Gam Dor",
                    "RAh": 4.267111111,
                    "DEd": -51.48666667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ]
            ]
        },
        {
            "Name": "Eridanus",
            "RAh": "1.628583333",
            "DEd": "-57.23666667",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Alp Eri",
                    "RAh": 1.628583333,
                    "DEd": -57.23666667
                },
                {
                    "id": 1,
                    "bfID": "Chi Eri",
                    "RAh": 1.932638889,
                    "DEd": -51.60888889
                },
                {
                    "id": 2,
                    "bfID": "Chi Eri",
                    "RAh": 1.932638889,
                    "DEd": -51.60888889
                },
                {
                    "id": 3,
                    "bfID": "Phi Eri",
                    "RAh": 2.275166667,
                    "DEd": -51.51222222
                },
                {
                    "id": 4,
                    "bfID": "Phi Eri",
                    "RAh": 2.275166667,
                    "DEd": -51.51222222
                },
                {
                    "id": 5,
                    "bfID": "Kap Eri",
                    "RAh": 2.44975,
                    "DEd": -47.70388889
                },
                {
                    "id": 6,
                    "bfID": "Kap Eri",
                    "RAh": 2.44975,
                    "DEd": -47.70388889
                },
                {
                    "id": 7,
                    "bfID": "",
                    "RAh": 2.663333333,
                    "DEd": -42.89166667
                },
                {
                    "id": 8,
                    "bfID": "",
                    "RAh": 2.663333333,
                    "DEd": -42.89166667
                },
                {
                    "id": 9,
                    "bfID": "Iot Eri",
                    "RAh": 2.677777778,
                    "DEd": -39.85555556
                },
                {
                    "id": 10,
                    "bfID": "Iot Eri",
                    "RAh": 2.677777778,
                    "DEd": -39.85555556
                },
                {
                    "id": 11,
                    "bfID": "The1Eri",
                    "RAh": 2.971027778,
                    "DEd": -40.30472222
                },
                {
                    "id": 12,
                    "bfID": "The1Eri",
                    "RAh": 2.971027778,
                    "DEd": -40.30472222
                },
                {
                    "id": 13,
                    "bfID": "",
                    "RAh": 3.332138889,
                    "DEd": -43.06972222
                },
                {
                    "id": 14,
                    "bfID": "",
                    "RAh": 3.332138889,
                    "DEd": -43.06972222
                },
                {
                    "id": 15,
                    "bfID": "",
                    "RAh": 3.809833333,
                    "DEd": -37.62222222
                },
                {
                    "id": 16,
                    "bfID": "",
                    "RAh": 3.809833333,
                    "DEd": -37.62222222
                },
                {
                    "id": 17,
                    "bfID": "",
                    "RAh": 3.82425,
                    "DEd": -36.20027778
                },
                {
                    "id": 18,
                    "bfID": "",
                    "RAh": 3.82425,
                    "DEd": -36.20027778
                },
                {
                    "id": 19,
                    "bfID": "41Ups4Eri",
                    "RAh": 4.29825,
                    "DEd": -33.79833333
                },
                {
                    "id": 20,
                    "bfID": "41Ups4Eri",
                    "RAh": 4.29825,
                    "DEd": -33.79833333
                },
                {
                    "id": 21,
                    "bfID": "43 Eri",
                    "RAh": 4.400611111,
                    "DEd": -34.01694444
                },
                {
                    "id": 22,
                    "bfID": "43 Eri",
                    "RAh": 4.400611111,
                    "DEd": -34.01694444
                },
                {
                    "id": 23,
                    "bfID": "52Ups2Eri",
                    "RAh": 4.5925,
                    "DEd": -30.56222222
                },
                {
                    "id": 24,
                    "bfID": "52Ups2Eri",
                    "RAh": 4.5925,
                    "DEd": -30.56222222
                },
                {
                    "id": 25,
                    "bfID": "27Tau6Eri",
                    "RAh": 3.780805556,
                    "DEd": -23.24972222
                },
                {
                    "id": 26,
                    "bfID": "27Tau6Eri",
                    "RAh": 3.780805556,
                    "DEd": -23.24972222
                },
                {
                    "id": 27,
                    "bfID": "19Tau5Eri",
                    "RAh": 3.563138889,
                    "DEd": -21.63277778
                },
                {
                    "id": 28,
                    "bfID": "19Tau5Eri",
                    "RAh": 3.563138889,
                    "DEd": -21.63277778
                },
                {
                    "id": 29,
                    "bfID": "16Tau4Eri",
                    "RAh": 3.325277778,
                    "DEd": -21.75777778
                },
                {
                    "id": 30,
                    "bfID": "16Tau4Eri",
                    "RAh": 3.325277778,
                    "DEd": -21.75777778
                },
                {
                    "id": 31,
                    "bfID": "11Tau3Eri",
                    "RAh": 3.039861111,
                    "DEd": -23.62444444
                },
                {
                    "id": 32,
                    "bfID": "11Tau3Eri",
                    "RAh": 3.039861111,
                    "DEd": -23.62444444
                },
                {
                    "id": 33,
                    "bfID": "1Tau1Eri",
                    "RAh": 2.751722222,
                    "DEd": -18.5725
                },
                {
                    "id": 34,
                    "bfID": "1Tau1Eri",
                    "RAh": 2.751722222,
                    "DEd": -18.5725
                },
                {
                    "id": 35,
                    "bfID": "3Eta Eri",
                    "RAh": 2.940472222,
                    "DEd": -8.898055556
                },
                {
                    "id": 36,
                    "bfID": "3Eta Eri",
                    "RAh": 2.940472222,
                    "DEd": -8.898055556
                },
                {
                    "id": 37,
                    "bfID": "13Zet Eri",
                    "RAh": 3.263888889,
                    "DEd": -8.819722222
                },
                {
                    "id": 38,
                    "bfID": "13Zet Eri",
                    "RAh": 3.263888889,
                    "DEd": -8.819722222
                },
                {
                    "id": 39,
                    "bfID": "18Eps Eri",
                    "RAh": 3.548833333,
                    "DEd": -9.458333333
                },
                {
                    "id": 40,
                    "bfID": "18Eps Eri",
                    "RAh": 3.548833333,
                    "DEd": -9.458333333
                },
                {
                    "id": 41,
                    "bfID": "23Del Eri",
                    "RAh": 3.720805556,
                    "DEd": -9.763333333
                },
                {
                    "id": 42,
                    "bfID": "23Del Eri",
                    "RAh": 3.720805556,
                    "DEd": -9.763333333
                },
                {
                    "id": 43,
                    "bfID": "48Nu Eri",
                    "RAh": 4.605305556,
                    "DEd": -3.3525
                },
                {
                    "id": 44,
                    "bfID": "48Nu Eri",
                    "RAh": 4.605305556,
                    "DEd": -3.3525
                },
                {
                    "id": 45,
                    "bfID": "57Mu Eri",
                    "RAh": 4.758361111,
                    "DEd": -3.254722222
                },
                {
                    "id": 46,
                    "bfID": "57Mu Eri",
                    "RAh": 4.758361111,
                    "DEd": -3.254722222
                },
                {
                    "id": 47,
                    "bfID": "61Ome Eri",
                    "RAh": 4.881583333,
                    "DEd": -5.452777778
                },
                {
                    "id": 48,
                    "bfID": "61Ome Eri",
                    "RAh": 4.881583333,
                    "DEd": -5.452777778
                },
                {
                    "id": 49,
                    "bfID": "67Bet Eri",
                    "RAh": 5.130833333,
                    "DEd": -5.086388889
                },
                {
                    "id": 50,
                    "bfID": "67Bet Eri",
                    "RAh": 5.130833333,
                    "DEd": -5.086388889
                },
                {
                    "id": 51,
                    "bfID": "69Lam Eri",
                    "RAh": 5.152444444,
                    "DEd": -8.754166667
                },
                {
                    "id": 52,
                    "bfID": "69Lam Eri",
                    "RAh": 5.152444444,
                    "DEd": -8.754166667
                },
                {
                    "id": 53,
                    "bfID": "53 Eri",
                    "RAh": 4.636333333,
                    "DEd": -14.30388889
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ],
                [
                    20,
                    21
                ],
                [
                    22,
                    23
                ],
                [
                    24,
                    25
                ],
                [
                    26,
                    27
                ],
                [
                    28,
                    29
                ],
                [
                    30,
                    31
                ],
                [
                    32,
                    33
                ],
                [
                    34,
                    35
                ],
                [
                    36,
                    37
                ],
                [
                    38,
                    39
                ],
                [
                    40,
                    41
                ],
                [
                    42,
                    43
                ],
                [
                    44,
                    45
                ],
                [
                    46,
                    47
                ],
                [
                    48,
                    49
                ],
                [
                    50,
                    51
                ],
                [
                    52,
                    53
                ]
            ]
        },
        {
            "Name": "Lynx",
            "RAh": "9.350916667",
            "DEd": "34.3925",
            "stars": [
                {
                    "id": 0,
                    "bfID": "40Alp Lyn",
                    "RAh": 9.350916667,
                    "DEd": 34.3925
                },
                {
                    "id": 1,
                    "bfID": "38 Lyn",
                    "RAh": 9.314083333,
                    "DEd": 36.8025
                },
                {
                    "id": 2,
                    "bfID": "38 Lyn",
                    "RAh": 9.314083333,
                    "DEd": 36.8025
                },
                {
                    "id": 3,
                    "bfID": "38 Lyn",
                    "RAh": 9.314083333,
                    "DEd": 36.8025
                },
                {
                    "id": 4,
                    "bfID": "38 Lyn",
                    "RAh": 9.314083333,
                    "DEd": 36.8025
                },
                {
                    "id": 5,
                    "bfID": "",
                    "RAh": 9.010666667,
                    "DEd": 41.78277778
                },
                {
                    "id": 6,
                    "bfID": "",
                    "RAh": 9.010666667,
                    "DEd": 41.78277778
                },
                {
                    "id": 7,
                    "bfID": "31 Lyn",
                    "RAh": 8.380583333,
                    "DEd": 43.18805556
                },
                {
                    "id": 8,
                    "bfID": "31 Lyn",
                    "RAh": 8.380583333,
                    "DEd": 43.18805556
                },
                {
                    "id": 9,
                    "bfID": "21 Lyn",
                    "RAh": 7.445222222,
                    "DEd": 49.21138889
                },
                {
                    "id": 10,
                    "bfID": "21 Lyn",
                    "RAh": 7.445222222,
                    "DEd": 49.21138889
                },
                {
                    "id": 11,
                    "bfID": "15 Lyn",
                    "RAh": 6.954583333,
                    "DEd": 58.4225
                },
                {
                    "id": 12,
                    "bfID": "15 Lyn",
                    "RAh": 6.954583333,
                    "DEd": 58.4225
                },
                {
                    "id": 13,
                    "bfID": "2 Lyn",
                    "RAh": 6.327055556,
                    "DEd": 59.01083333
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ]
            ]
        },
        {
            "Name": "Puppis",
            "RAh": "8.125722222",
            "DEd": "-24.30416667",
            "stars": [
                {
                    "id": 0,
                    "bfID": "15Rho Pup",
                    "RAh": 8.125722222,
                    "DEd": -24.30416667
                },
                {
                    "id": 1,
                    "bfID": "",
                    "RAh": 7.817138889,
                    "DEd": -24.91222222
                },
                {
                    "id": 2,
                    "bfID": "",
                    "RAh": 7.817138889,
                    "DEd": -24.91222222
                },
                {
                    "id": 3,
                    "bfID": "Pi Pup",
                    "RAh": 7.285722222,
                    "DEd": -37.0975
                },
                {
                    "id": 4,
                    "bfID": "Pi Pup",
                    "RAh": 7.285722222,
                    "DEd": -37.0975
                },
                {
                    "id": 5,
                    "bfID": "Nu Pup",
                    "RAh": 6.629361111,
                    "DEd": -43.19611111
                },
                {
                    "id": 6,
                    "bfID": "Nu Pup",
                    "RAh": 6.629361111,
                    "DEd": -43.19611111
                },
                {
                    "id": 7,
                    "bfID": "Tau Pup",
                    "RAh": 6.832277778,
                    "DEd": -50.61472222
                },
                {
                    "id": 8,
                    "bfID": "Tau Pup",
                    "RAh": 6.832277778,
                    "DEd": -50.61472222
                },
                {
                    "id": 9,
                    "bfID": "Sig Pup",
                    "RAh": 7.487166667,
                    "DEd": -43.30138889
                },
                {
                    "id": 10,
                    "bfID": "Sig Pup",
                    "RAh": 7.487166667,
                    "DEd": -43.30138889
                },
                {
                    "id": 11,
                    "bfID": "Zet Pup",
                    "RAh": 8.05975,
                    "DEd": -40.00333333
                },
                {
                    "id": 12,
                    "bfID": "Zet Pup",
                    "RAh": 8.05975,
                    "DEd": -40.00333333
                },
                {
                    "id": 13,
                    "bfID": "15Rho Pup",
                    "RAh": 8.125722222,
                    "DEd": -24.30416667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ]
            ]
        },
        {
            "Name": "Vela",
            "RAh": "8.158888889",
            "DEd": "-47.33666667",
            "stars": [
                {
                    "id": 0,
                    "bfID": "Gam2Vel",
                    "RAh": 8.158888889,
                    "DEd": -47.33666667
                },
                {
                    "id": 1,
                    "bfID": "",
                    "RAh": 8.671555556,
                    "DEd": -52.92194444
                },
                {
                    "id": 2,
                    "bfID": "",
                    "RAh": 8.671555556,
                    "DEd": -52.92194444
                },
                {
                    "id": 3,
                    "bfID": "Del Vel",
                    "RAh": 8.745055556,
                    "DEd": -54.70833333
                },
                {
                    "id": 4,
                    "bfID": "Del Vel",
                    "RAh": 8.745055556,
                    "DEd": -54.70833333
                },
                {
                    "id": 5,
                    "bfID": "Kap Vel",
                    "RAh": 9.368555556,
                    "DEd": -55.01083333
                },
                {
                    "id": 6,
                    "bfID": "Kap Vel",
                    "RAh": 9.368555556,
                    "DEd": -55.01083333
                },
                {
                    "id": 7,
                    "bfID": "Phi Vel",
                    "RAh": 9.947722222,
                    "DEd": -54.56777778
                },
                {
                    "id": 8,
                    "bfID": "Phi Vel",
                    "RAh": 9.947722222,
                    "DEd": -54.56777778
                },
                {
                    "id": 9,
                    "bfID": "Mu Vel",
                    "RAh": 10.7795,
                    "DEd": -49.42
                },
                {
                    "id": 10,
                    "bfID": "Mu Vel",
                    "RAh": 10.7795,
                    "DEd": -49.42
                },
                {
                    "id": 11,
                    "bfID": "",
                    "RAh": 10.62169444,
                    "DEd": -48.22583333
                },
                {
                    "id": 12,
                    "bfID": "",
                    "RAh": 10.62169444,
                    "DEd": -48.22583333
                },
                {
                    "id": 13,
                    "bfID": "",
                    "RAh": 10.24561111,
                    "DEd": -42.12194444
                },
                {
                    "id": 14,
                    "bfID": "",
                    "RAh": 10.24561111,
                    "DEd": -42.12194444
                },
                {
                    "id": 15,
                    "bfID": "Psi Vel",
                    "RAh": 9.511666667,
                    "DEd": -40.46666667
                },
                {
                    "id": 16,
                    "bfID": "Psi Vel",
                    "RAh": 9.511666667,
                    "DEd": -40.46666667
                },
                {
                    "id": 17,
                    "bfID": "Lam Vel",
                    "RAh": 9.133277778,
                    "DEd": -43.4325
                },
                {
                    "id": 18,
                    "bfID": "Lam Vel",
                    "RAh": 9.133277778,
                    "DEd": -43.4325
                },
                {
                    "id": 19,
                    "bfID": "Gam2Vel",
                    "RAh": 8.158888889,
                    "DEd": -47.33666667
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    2,
                    3
                ],
                [
                    4,
                    5
                ],
                [
                    6,
                    7
                ],
                [
                    8,
                    9
                ],
                [
                    10,
                    11
                ],
                [
                    12,
                    13
                ],
                [
                    14,
                    15
                ],
                [
                    16,
                    17
                ],
                [
                    18,
                    19
                ]
            ]
        },
        {
            "Name": "Camelopardalis",
            "RAh": 4.900833333,
            "DEd": 66.34277778,
            "stars": [
                {
                    "id": "0",
                    "bfID": "43 Cam",
                    "RAh": 6.895055556,
                    "DEd": 68.88833333
                },
                {
                    "id": "1",
                    "bfID": "36 Cam",
                    "RAh": 6.214194444,
                    "DEd": 65.71833333
                },
                {
                    "id": "2",
                    "bfID": "9Alp Cam",
                    "RAh": 4.900833333,
                    "DEd": 66.34277778
                },
                {
                    "id": "3",
                    "bfID": "Gam Cam",
                    "RAh": 3.839305556,
                    "DEd": 71.33222222
                },
                {
                    "id": "4",
                    "bfID": "10Bet Cam",
                    "RAh": 5.056972222,
                    "DEd": 60.44222222
                },
                {
                    "id": "5",
                    "bfID": "7 Cam",
                    "RAh": 4.954777778,
                    "DEd": 53.75222222
                }
            ],
            "lines": [
                [
                    0,
                    1
                ],
                [
                    1,
                    2
                ],
                [
                    2,
                    3
                ],
                [
                    2,
                    4
                ],
                [
                    4,
                    5
                ]
            ]
        }
    ]
}